/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Lusca Search
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActiveProjectValidation
 */
export interface ActiveProjectValidation {
    /**
     * 
     * @type {string}
     * @memberof ActiveProjectValidation
     */
    'jobId': string;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ActiveProjectValidation
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {string}
     * @memberof ActiveProjectValidation
     */
    'startedAt': string;
}
/**
 * 
 * @export
 * @interface AmountDto
 */
export interface AmountDto {
    /**
     * The numeric amount value as a string
     * @type {string}
     * @memberof AmountDto
     */
    'value'?: string;
    /**
     * The ISO currency code
     * @type {string}
     * @memberof AmountDto
     */
    'currencyCode'?: string;
}
/**
 * 
 * @export
 * @interface AsanaAuthorizationCompleteRequest
 */
export interface AsanaAuthorizationCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationCompleteRequest
     */
    'sessionId': string;
}
/**
 * 
 * @export
 * @interface AsanaAuthorizationCompleteResponse
 */
export interface AsanaAuthorizationCompleteResponse {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationCompleteResponse
     */
    'status': AsanaAuthorizationCompleteResponseStatusEnum;
}

export const AsanaAuthorizationCompleteResponseStatusEnum = {
    Connected: 'connected'
} as const;

export type AsanaAuthorizationCompleteResponseStatusEnum = typeof AsanaAuthorizationCompleteResponseStatusEnum[keyof typeof AsanaAuthorizationCompleteResponseStatusEnum];

/**
 * 
 * @export
 * @interface AsanaAuthorizationRequest
 */
export interface AsanaAuthorizationRequest {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationRequest
     */
    'state': string;
    /**
     * 
     * @type {boolean}
     * @memberof AsanaAuthorizationRequest
     */
    'forceAuthentication'?: boolean;
}
/**
 * 
 * @export
 * @interface AsanaAuthorizationResponse
 */
export interface AsanaAuthorizationResponse {
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationResponse
     */
    'status': AsanaAuthorizationResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationResponse
     */
    'authorizationUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsanaAuthorizationResponse
     */
    'sessionId'?: string;
}

export const AsanaAuthorizationResponseStatusEnum = {
    Connected: 'connected',
    AuthorizationRequired: 'authorization_required'
} as const;

export type AsanaAuthorizationResponseStatusEnum = typeof AsanaAuthorizationResponseStatusEnum[keyof typeof AsanaAuthorizationResponseStatusEnum];

/**
 * 
 * @export
 * @interface AsanaLink
 */
export interface AsanaLink {
    /**
     * 
     * @type {string}
     * @memberof AsanaLink
     */
    'projectGid': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaLink
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaLink
     */
    'projectUrl': string;
}
/**
 * 
 * @export
 * @interface AsanaLinkPreviewRequest
 */
export interface AsanaLinkPreviewRequest {
    /**
     * Asana project URL or numeric project GID
     * @type {string}
     * @memberof AsanaLinkPreviewRequest
     */
    'projectReference': string;
}
/**
 * 
 * @export
 * @interface AsanaLinkUpdate
 */
export interface AsanaLinkUpdate {
    /**
     * 
     * @type {string}
     * @memberof AsanaLinkUpdate
     */
    'projectGid': string;
    /**
     * 
     * @type {number}
     * @memberof AsanaLinkUpdate
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface AsanaProjectPreview
 */
export interface AsanaProjectPreview {
    /**
     * 
     * @type {AsanaProjectReference}
     * @memberof AsanaProjectPreview
     */
    'project': AsanaProjectReference;
}
/**
 * 
 * @export
 * @interface AsanaProjectReference
 */
export interface AsanaProjectReference {
    /**
     * 
     * @type {string}
     * @memberof AsanaProjectReference
     */
    'gid': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaProjectReference
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AsanaProjectReference
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface Cbe
 */
export interface Cbe {
    /**
     * 
     * @type {string}
     * @memberof Cbe
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface CbeSummaryResponse
 */
export interface CbeSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponse
     */
    'totalCbes'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CbeSummaryResponse
     */
    'byUsecase'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CbeSummaryResponse
     */
    'byAccountingOperation'?: { [key: string]: number; };
    /**
     * 
     * @type {CbeSummaryResponsePublishStatus}
     * @memberof CbeSummaryResponse
     */
    'publishStatus'?: CbeSummaryResponsePublishStatus;
}
/**
 * 
 * @export
 * @interface CbeSummaryResponsePublishStatus
 */
export interface CbeSummaryResponsePublishStatus {
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'published'?: number;
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'skipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof CbeSummaryResponsePublishStatus
     */
    'unknown'?: number;
}
/**
 * 
 * @export
 * @interface ChatAsyncResponse
 */
export interface ChatAsyncResponse {
    /**
     * Id to poll on chat-status
     * @type {string}
     * @memberof ChatAsyncResponse
     */
    'jobId'?: string;
    /**
     * 
     * @type {ChatJobStatus}
     * @memberof ChatAsyncResponse
     */
    'status'?: ChatJobStatus;
}
/**
 * 
 * @export
 * @interface ChatFollowupsResponse
 */
export interface ChatFollowupsResponse {
    /**
     * Suggested follow-up questions
     * @type {Array<string>}
     * @memberof ChatFollowupsResponse
     */
    'followups'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatJobStatus = {
    Pending: 'PENDING',
    Done: 'DONE',
    Failed: 'FAILED'
} as const;

export type ChatJobStatus = typeof ChatJobStatus[keyof typeof ChatJobStatus];

/**
 * 
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'role': ChatMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
}

export const ChatMessageRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type ChatMessageRoleEnum = typeof ChatMessageRoleEnum[keyof typeof ChatMessageRoleEnum];

/**
 * 
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * The transaction/order the conversation is scoped to
     * @type {string}
     * @memberof ChatRequest
     */
    'transactionId': string;
    /**
     * Full conversation history, oldest first
     * @type {Array<ChatMessage>}
     * @memberof ChatRequest
     */
    'messages': Array<ChatMessage>;
}
/**
 * 
 * @export
 * @interface ChatResponse
 */
export interface ChatResponse {
    /**
     * Assistant reply text
     * @type {string}
     * @memberof ChatResponse
     */
    'content'?: string;
    /**
     * Names of the data sources and actions used to produce the answer
     * @type {Array<string>}
     * @memberof ChatResponse
     */
    'toolsUsed'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChatStatusResponse
 */
export interface ChatStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatStatusResponse
     */
    'jobId'?: string;
    /**
     * 
     * @type {ChatJobStatus}
     * @memberof ChatStatusResponse
     */
    'status'?: ChatJobStatus;
    /**
     * Steps completed so far, oldest first
     * @type {Array<string>}
     * @memberof ChatStatusResponse
     */
    'progress'?: Array<string>;
    /**
     * Assistant reply text, present once status is DONE
     * @type {string}
     * @memberof ChatStatusResponse
     */
    'content'?: string;
    /**
     * Names of the data sources and actions used to produce the answer
     * @type {Array<string>}
     * @memberof ChatStatusResponse
     */
    'toolsUsed'?: Array<string>;
    /**
     * Failure reason, present once status is FAILED
     * @type {string}
     * @memberof ChatStatusResponse
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ChatUatAction
 */
export interface ChatUatAction {
    /**
     * Canonical tool name used as an opaque action identifier
     * @type {string}
     * @memberof ChatUatAction
     */
    'type': string;
    /**
     * Tool-specific status retained for diagnostics and specialized clients
     * @type {string}
     * @memberof ChatUatAction
     */
    'status': string;
    /**
     * Tool-independent presentation category. confirmed means only that the action-specific acknowledgement was verified.
     * @type {string}
     * @memberof ChatUatAction
     */
    'outcome': ChatUatActionOutcomeEnum;
    /**
     * Short deterministic heading for the action outcome
     * @type {string}
     * @memberof ChatUatAction
     */
    'summary': string;
    /**
     * 
     * @type {ChatUatActionReference}
     * @memberof ChatUatAction
     */
    'reference'?: ChatUatActionReference;
}

export const ChatUatActionOutcomeEnum = {
    Confirmed: 'confirmed',
    Uncertain: 'uncertain',
    Failed: 'failed'
} as const;

export type ChatUatActionOutcomeEnum = typeof ChatUatActionOutcomeEnum[keyof typeof ChatUatActionOutcomeEnum];

/**
 * 
 * @export
 * @interface ChatUatActionReference
 */
export interface ChatUatActionReference {
    /**
     * Human-readable label for the copyable reference
     * @type {string}
     * @memberof ChatUatActionReference
     */
    'label': string;
    /**
     * Exact, case-sensitive reference value. Clients must not trim or otherwise normalize it.
     * @type {string}
     * @memberof ChatUatActionReference
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface ChatUatActionResponse
 */
export interface ChatUatActionResponse {
    /**
     * Echo of the conversation id to send on the next turn
     * @type {string}
     * @memberof ChatUatActionResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatActionResponse
     */
    'responseType': ChatUatActionResponseResponseTypeEnum;
    /**
     * Safe explanatory text for the action outcome
     * @type {string}
     * @memberof ChatUatActionResponse
     */
    'conversational': string;
    /**
     * 
     * @type {ChatUatAction}
     * @memberof ChatUatActionResponse
     */
    'action': ChatUatAction;
}

export const ChatUatActionResponseResponseTypeEnum = {
    Action: 'action'
} as const;

export type ChatUatActionResponseResponseTypeEnum = typeof ChatUatActionResponseResponseTypeEnum[keyof typeof ChatUatActionResponseResponseTypeEnum];

/**
 * Optional presentation preference. It changes explanation emphasis and suggested next steps but never evidence, authorization, or verdicts.
 * @export
 * @enum {string}
 */

export const ChatUatAudience = {
    Customer: 'customer',
    Engineer: 'engineer'
} as const;

export type ChatUatAudience = typeof ChatUatAudience[keyof typeof ChatUatAudience];

/**
 * 
 * @export
 * @interface ChatUatContentFacts
 */
export interface ChatUatContentFacts {
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'schemaVersion': ChatUatContentFactsSchemaVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'status': ChatUatContentFactsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'orderId': string;
    /**
     * 
     * @type {Stage}
     * @memberof ChatUatContentFacts
     */
    'stage': Stage;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContentFacts
     */
    'contentType': ChatUatContentFactsContentTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatUatContentFacts
     */
    'sourceRefs': Array<string>;
}

export const ChatUatContentFactsSchemaVersionEnum = {
    _1: '1'
} as const;

export type ChatUatContentFactsSchemaVersionEnum = typeof ChatUatContentFactsSchemaVersionEnum[keyof typeof ChatUatContentFactsSchemaVersionEnum];
export const ChatUatContentFactsStatusEnum = {
    Ok: 'ok'
} as const;

export type ChatUatContentFactsStatusEnum = typeof ChatUatContentFactsStatusEnum[keyof typeof ChatUatContentFactsStatusEnum];
export const ChatUatContentFactsContentTypeEnum = {
    Episode: 'episode',
    Movie: 'movie'
} as const;

export type ChatUatContentFactsContentTypeEnum = typeof ChatUatContentFactsContentTypeEnum[keyof typeof ChatUatContentFactsContentTypeEnum];

/**
 * 
 * @export
 * @interface ChatUatContextReference
 */
export interface ChatUatContextReference {
    /**
     * 
     * @type {string}
     * @memberof ChatUatContextReference
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatContextReference
     */
    'taskGid': string;
    /**
     * Optional browser display value. The backend verifies it against the persisted validation case and supplies the authoritative value to AgentCore.
     * @type {string}
     * @memberof ChatUatContextReference
     */
    'orderId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatUatError
 */
export interface ChatUatError {
    /**
     * Safe request or service error
     * @type {string}
     * @memberof ChatUatError
     */
    'error': string;
}
/**
 * Optional bounded failure category supplied by newer Agent runtimes. Clients must use the safe error string for backward compatibility and must not display this internal code as prose.
 * @export
 * @enum {string}
 */

export const ChatUatFailureCode = {
    ReviewTooLarge: 'review_too_large',
    Timeout: 'timeout',
    ExecutionLimit: 'execution_limit',
    Cancelled: 'cancelled',
    Lost: 'lost',
    InternalError: 'internal_error'
} as const;

export type ChatUatFailureCode = typeof ChatUatFailureCode[keyof typeof ChatUatFailureCode];

/**
 * 
 * @export
 * @interface ChatUatFeedbackContext
 */
export interface ChatUatFeedbackContext {
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackContext
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackContext
     */
    'taskGid': string;
}
/**
 * 
 * @export
 * @interface ChatUatFeedbackRequest
 */
export interface ChatUatFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'feedbackId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'responseFingerprint': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'rating': ChatUatFeedbackRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'reason'?: ChatUatFeedbackRequestReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {ChatUatFeedbackContext}
     * @memberof ChatUatFeedbackRequest
     */
    'context'?: ChatUatFeedbackContext;
}

export const ChatUatFeedbackRequestRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type ChatUatFeedbackRequestRatingEnum = typeof ChatUatFeedbackRequestRatingEnum[keyof typeof ChatUatFeedbackRequestRatingEnum];
export const ChatUatFeedbackRequestReasonEnum = {
    Incorrect: 'incorrect',
    MissingEvidence: 'missing_evidence',
    Unclear: 'unclear',
    TooSlow: 'too_slow',
    Other: 'other'
} as const;

export type ChatUatFeedbackRequestReasonEnum = typeof ChatUatFeedbackRequestReasonEnum[keyof typeof ChatUatFeedbackRequestReasonEnum];

/**
 * 
 * @export
 * @interface ChatUatFeedbackResponse
 */
export interface ChatUatFeedbackResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatFeedbackResponse
     */
    'feedbackId': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatUatFeedbackResponse
     */
    'accepted': ChatUatFeedbackResponseAcceptedEnum;
}

export const ChatUatFeedbackResponseAcceptedEnum = {
    True: true
} as const;

export type ChatUatFeedbackResponseAcceptedEnum = typeof ChatUatFeedbackResponseAcceptedEnum[keyof typeof ChatUatFeedbackResponseAcceptedEnum];

/**
 * 
 * @export
 * @interface ChatUatJobCompletedResponse
 */
export interface ChatUatJobCompletedResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobCompletedResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobCompletedResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobCompletedResponse
     */
    'status': ChatUatJobCompletedResponseStatusEnum;
    /**
     * 
     * @type {ChatUatResponse}
     * @memberof ChatUatJobCompletedResponse
     */
    'response': ChatUatResponse;
}

export const ChatUatJobCompletedResponseStatusEnum = {
    Completed: 'completed'
} as const;

export type ChatUatJobCompletedResponseStatusEnum = typeof ChatUatJobCompletedResponseStatusEnum[keyof typeof ChatUatJobCompletedResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatJobFailedResponse
 */
export interface ChatUatJobFailedResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'status': ChatUatJobFailedResponseStatusEnum;
    /**
     * Safe terminal error suitable for display
     * @type {string}
     * @memberof ChatUatJobFailedResponse
     */
    'error': string;
    /**
     * 
     * @type {ChatUatFailureCode}
     * @memberof ChatUatJobFailedResponse
     */
    'failureCode'?: ChatUatFailureCode;
}

export const ChatUatJobFailedResponseStatusEnum = {
    Failed: 'failed'
} as const;

export type ChatUatJobFailedResponseStatusEnum = typeof ChatUatJobFailedResponseStatusEnum[keyof typeof ChatUatJobFailedResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatJobPendingResponse
 */
export interface ChatUatJobPendingResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobPendingResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobPendingResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobPendingResponse
     */
    'status': ChatUatJobPendingResponseStatusEnum;
    /**
     * Minimum delay before the next status request
     * @type {number}
     * @memberof ChatUatJobPendingResponse
     */
    'retryAfterMs': number;
}

export const ChatUatJobPendingResponseStatusEnum = {
    Pending: 'pending',
    Running: 'running'
} as const;

export type ChatUatJobPendingResponseStatusEnum = typeof ChatUatJobPendingResponseStatusEnum[keyof typeof ChatUatJobPendingResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatJobRequest
 */
export interface ChatUatJobRequest {
    /**
     * Client-generated job key used for best-effort deduplication within the current AgentCore runtime process. A runtime replacement or restart can lose that state. After an ambiguous submission or a state_lost response, the original outcome may be unknown and the client must not automatically submit the POST again.
     * @type {string}
     * @memberof ChatUatJobRequest
     */
    'jobId': string;
    /**
     * The user\'s non-whitespace question
     * @type {string}
     * @memberof ChatUatJobRequest
     */
    'prompt': string;
    /**
     * Client-generated conversation id reused for status requests and subsequent turns. The backend binds it to the authenticated actor, and the agent rehydrates history from Memory. Do not automatically resubmit an ambiguously acknowledged or state-lost job.
     * @type {string}
     * @memberof ChatUatJobRequest
     */
    'conversationId': string;
    /**
     * 
     * @type {ChatUatAudience}
     * @memberof ChatUatJobRequest
     */
    'audience'?: ChatUatAudience;
    /**
     * 
     * @type {ChatUatContextReference}
     * @memberof ChatUatJobRequest
     */
    'context'?: ChatUatContextReference;
}
/**
 * @type ChatUatJobStartResponse
 * A pending, running, completed, or failed runtime-local job returned during submission.
 * @export
 */
export type ChatUatJobStartResponse = ChatUatJobCompletedResponse | ChatUatJobFailedResponse | ChatUatJobPendingResponse;

/**
 * 
 * @export
 * @interface ChatUatJobStateLostResponse
 */
export interface ChatUatJobStateLostResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'status': ChatUatJobStateLostResponseStatusEnum;
    /**
     * Safe terminal uncertainty message. The original action outcome may be unknown, so clients must not automatically resubmit the job. Clients may continue the existing conversation.
     * @type {string}
     * @memberof ChatUatJobStateLostResponse
     */
    'error': string;
}

export const ChatUatJobStateLostResponseStatusEnum = {
    StateLost: 'state_lost'
} as const;

export type ChatUatJobStateLostResponseStatusEnum = typeof ChatUatJobStateLostResponseStatusEnum[keyof typeof ChatUatJobStateLostResponseStatusEnum];

/**
 * @type ChatUatJobStatusResponse
 * A pending, running, completed, failed, or state-lost background turn. Job state and deduplication are local to the AgentCore runtime process. If AgentCore replaces that runtime, state_lost is terminal uncertainty: the original outcome may be unknown, so clients must not automatically submit that job again. The conversation itself remains usable.
 * @export
 */
export type ChatUatJobStatusResponse = ChatUatJobCompletedResponse | ChatUatJobFailedResponse | ChatUatJobPendingResponse | ChatUatJobStateLostResponse;

/**
 * A non-review conversational turn, such as a request for a missing action input. It is not evidence of an action outcome.
 * @export
 * @interface ChatUatMessageResponse
 */
export interface ChatUatMessageResponse {
    /**
     * Echo of the conversation id to send on the next turn
     * @type {string}
     * @memberof ChatUatMessageResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatMessageResponse
     */
    'responseType': ChatUatMessageResponseResponseTypeEnum;
    /**
     * The text-only chat answer
     * @type {string}
     * @memberof ChatUatMessageResponse
     */
    'conversational': string;
}

export const ChatUatMessageResponseResponseTypeEnum = {
    Message: 'message'
} as const;

export type ChatUatMessageResponseResponseTypeEnum = typeof ChatUatMessageResponseResponseTypeEnum[keyof typeof ChatUatMessageResponseResponseTypeEnum];

/**
 * @type ChatUatResponse
 * A discriminated ChatUAT review, text-only message, or structured action outcome. The backend also enforces each variant at runtime.
 * @export
 */
export type ChatUatResponse = ChatUatActionResponse | ChatUatMessageResponse | ChatUatReviewResponse;

/**
 * 
 * @export
 * @interface ChatUatReviewResponse
 */
export interface ChatUatReviewResponse {
    /**
     * Echo of the conversation id to send on the next turn
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'responseType': ChatUatReviewResponseResponseTypeEnum;
    /**
     * The chat answer text
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'conversational': string;
    /**
     * The self-contained review block, present only for a review response
     * @type {string}
     * @memberof ChatUatReviewResponse
     */
    'artefact': string;
    /**
     * The evidence sources cited by a review response; present only for a review
     * @type {Set<string>}
     * @memberof ChatUatReviewResponse
     */
    'groundedIn': Set<ChatUatReviewResponseGroundedInEnum>;
}

export const ChatUatReviewResponseResponseTypeEnum = {
    Review: 'review'
} as const;

export type ChatUatReviewResponseResponseTypeEnum = typeof ChatUatReviewResponseResponseTypeEnum[keyof typeof ChatUatReviewResponseResponseTypeEnum];
export const ChatUatReviewResponseGroundedInEnum = {
    OrderData: 'order data',
    ClassificationDescription: 'classification description',
    CuratedKnowledge: 'curated knowledge'
} as const;

export type ChatUatReviewResponseGroundedInEnum = typeof ChatUatReviewResponseGroundedInEnum[keyof typeof ChatUatReviewResponseGroundedInEnum];

/**
 * 
 * @export
 * @interface ChatUatValidationJobResponse
 */
export interface ChatUatValidationJobResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationJobResponse
     */
    'jobId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationJobResponse
     */
    'status': ChatUatValidationJobResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ChatUatValidationJobResponse
     */
    'retryAfterMs'?: number;
    /**
     * 
     * @type {ProjectValidationProgress}
     * @memberof ChatUatValidationJobResponse
     */
    'progress'?: ProjectValidationProgress;
    /**
     * 
     * @type {ProjectValidationResult}
     * @memberof ChatUatValidationJobResponse
     */
    'result'?: ProjectValidationResult;
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationJobResponse
     */
    'error'?: string;
}

export const ChatUatValidationJobResponseStatusEnum = {
    Pending: 'pending',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    StateLost: 'state_lost'
} as const;

export type ChatUatValidationJobResponseStatusEnum = typeof ChatUatValidationJobResponseStatusEnum[keyof typeof ChatUatValidationJobResponseStatusEnum];

/**
 * 
 * @export
 * @interface ChatUatValidationRun
 */
export interface ChatUatValidationRun {
    /**
     * 
     * @type {ProjectValidationRunSummary}
     * @memberof ChatUatValidationRun
     */
    'run': ProjectValidationRunSummary;
    /**
     * 
     * @type {Array<ProjectValidationCase>}
     * @memberof ChatUatValidationRun
     */
    'cases': Array<ProjectValidationCase>;
}
/**
 * 
 * @export
 * @interface ChatUatValidationStartRequest
 */
export interface ChatUatValidationStartRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationStartRequest
     */
    'jobId': string;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ChatUatValidationStartRequest
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {number}
     * @memberof ChatUatValidationStartRequest
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface ChatUatValidationState
 */
export interface ChatUatValidationState {
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationState
     */
    'schemaVersion': ChatUatValidationStateSchemaVersionEnum;
    /**
     * 
     * @type {number}
     * @memberof ChatUatValidationState
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof ChatUatValidationState
     */
    'updatedAt': string;
    /**
     * 
     * @type {AsanaLink}
     * @memberof ChatUatValidationState
     */
    'asanaLink'?: AsanaLink;
    /**
     * 
     * @type {ActiveProjectValidation}
     * @memberof ChatUatValidationState
     */
    'activeValidation'?: ActiveProjectValidation;
    /**
     * 
     * @type {ProjectValidationRunSummary}
     * @memberof ChatUatValidationState
     */
    'latestValidationRun'?: ProjectValidationRunSummary;
    /**
     * 
     * @type {Array<ProjectValidationRunSummary>}
     * @memberof ChatUatValidationState
     */
    'runs': Array<ProjectValidationRunSummary>;
}

export const ChatUatValidationStateSchemaVersionEnum = {
    _1: '1'
} as const;

export type ChatUatValidationStateSchemaVersionEnum = typeof ChatUatValidationStateSchemaVersionEnum[keyof typeof ChatUatValidationStateSchemaVersionEnum];

/**
 * 
 * @export
 * @interface ClassificationEntry
 */
export interface ClassificationEntry {
    /**
     * 
     * @type {string}
     * @memberof ClassificationEntry
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ClassificationEntry
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationEntry
     */
    'isFailure': boolean;
}
/**
 * 
 * @export
 * @interface CreateShadowTestRequest
 */
export interface CreateShadowTestRequest {
    /**
     * Marketplace code (e.g., US, ROW_NA)
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'marketplace': string;
    /**
     * GL Product Group ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'glProductGroupId': string;
    /**
     * List of transaction IDs to test
     * @type {Array<string>}
     * @memberof CreateShadowTestRequest
     */
    'transactionIds': Array<string>;
    /**
     * Country code (e.g., AR, US, PE)
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'countryCode': string;
    /**
     * Order date (ISO format)
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'orderDate'?: string;
    /**
     * Accounting Unique ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'auid'?: string;
    /**
     * Subscription ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'subscriptionId'?: string;
    /**
     * Subscription period number
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'periodNumber'?: string;
    /**
     * Delivery Packet Item ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'deliveryPacketItemId'?: string;
    /**
     * Digital Order ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'digitalOrderID'?: string;
    /**
     * Finance Tag Auth Reference ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'financeTagAuthReferenceId'?: string;
    /**
     * Return ID
     * @type {string}
     * @memberof CreateShadowTestRequest
     */
    'returnID'?: string;
}
/**
 * 
 * @export
 * @interface DLQInfoResult
 */
export interface DLQInfoResult {
    /**
     * The status of the DLQ query (e.g., \"pending\", \"completed\", \"failed\")
     * @type {string}
     * @memberof DLQInfoResult
     */
    'status': string;
    /**
     * The ID of the query execution (present when status is \"pending\")
     * @type {string}
     * @memberof DLQInfoResult
     */
    'queryExecutionId'?: string;
    /**
     * Whether the order is in DLQ (present when status is \"completed\")
     * @type {boolean}
     * @memberof DLQInfoResult
     */
    'inDLQ'?: boolean;
    /**
     * The DLQ items (present when status is \"completed\" and inDLQ is true)
     * @type {Array<DLQItem>}
     * @memberof DLQInfoResult
     */
    'dlqItems'?: Array<DLQItem>;
    /**
     * 
     * @type {string}
     * @memberof DLQInfoResult
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DLQItem
 */
export interface DLQItem {
    /**
     * The primary key of the DLQ item (use this for redrive operations)
     * @type {string}
     * @memberof DLQItem
     */
    'pk': string;
    /**
     * The name of the queue where the message failed
     * @type {string}
     * @memberof DLQItem
     */
    'eventsourcekey': string;
    /**
     * The timestamp when the message failed processing
     * @type {string}
     * @memberof DLQItem
     */
    'timestamp': string;
    /**
     * 
     * @type {DLQItemProcessedBody}
     * @memberof DLQItem
     */
    'processed_body': DLQItemProcessedBody;
    /**
     * Indicates whether the message is a raw string (true) or valid JSON object (false)
     * @type {boolean}
     * @memberof DLQItem
     */
    'is_malformed_json': boolean;
    /**
     * The type of the error that occurred during processing
     * @type {string}
     * @memberof DLQItem
     */
    'error_type': string;
    /**
     * The message of the error that occurred during processing
     * @type {string}
     * @memberof DLQItem
     */
    'error_message': string;
    /**
     * The stack trace of the error that occurred during processing
     * @type {string}
     * @memberof DLQItem
     */
    'error_stack_trace'?: string;
    /**
     * The SQS message ID (for reference only, not used for redrive)
     * @type {string}
     * @memberof DLQItem
     */
    'message_id'?: string;
}
/**
 * @type DLQItemProcessedBody
 * The message body, either as a raw string (if malformed) or parsed JSON object
 * @export
 */
export type DLQItemProcessedBody = string | { [key: string]: any; };

/**
 * 
 * @export
 * @interface DLQRedriveInfoResult
 */
export interface DLQRedriveInfoResult {
    /**
     * The status of the DLQ query (e.g., \"PENDING\", \"COMPLETED\", \"ERROR\")
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'status': string;
    /**
     * The ID of the redrive execution (present when status is \"PENDING\")
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'executionArn'?: string;
    /**
     * 
     * @type {DLQRedriveInfoResultResult}
     * @memberof DLQRedriveInfoResult
     */
    'result'?: DLQRedriveInfoResultResult;
    /**
     * 
     * @type {DLQRedriveInfoResultMetadata}
     * @memberof DLQRedriveInfoResult
     */
    'metadata'?: DLQRedriveInfoResultMetadata;
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveInfoResult
     */
    'error'?: string;
}
/**
 * Execution metadata for the detail view (who/when/what was redriven)
 * @export
 * @interface DLQRedriveInfoResultMetadata
 */
export interface DLQRedriveInfoResultMetadata {
    /**
     * Alias of the user who started the redrive
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'executor'?: string;
    /**
     * Epoch seconds when the redrive was started
     * @type {number}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'timestamp'?: number;
    /**
     * Whether the redrive was a dry run
     * @type {boolean}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'dryRun'?: boolean;
    /**
     * Whether the redrive was a delete-without-redrive deletion
     * @type {boolean}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'deleteWithoutRedriving'?: boolean;
    /**
     * MCM id supplied for a delete-without-redrive deletion
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'mcmId'?: string;
    /**
     * Human-readable request type (\"Redrive\", \"Dry run\", \"Delete without redrive\")
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'requestType'?: string;
    /**
     * Number of inline message ids, when provided inline
     * @type {number}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'messageCount'?: number;
    /**
     * S3 URI of the uploaded message-id file, when provided as a file
     * @type {string}
     * @memberof DLQRedriveInfoResultMetadata
     */
    'messageIdsS3Uri'?: string;
}
/**
 * 
 * @export
 * @interface DLQRedriveInfoResultResult
 */
export interface DLQRedriveInfoResultResult {
    /**
     * Mapping of messageId to status (SUCCESS, DRY_RUN, ERROR, NOT_FOUND)
     * @type {{ [key: string]: any; }}
     * @memberof DLQRedriveInfoResultResult
     */
    'redrivenMessages'?: { [key: string]: any; };
    /**
     * True when a large file redrive\'s per-row results were capped
     * @type {boolean}
     * @memberof DLQRedriveInfoResultResult
     */
    'truncated'?: boolean;
    /**
     * S3 prefix holding the full per-row results (present when truncated)
     * @type {string}
     * @memberof DLQRedriveInfoResultResult
     */
    'resultsS3Uri'?: string;
    /**
     * 
     * @type {DLQRedriveInfoResultResultCounts}
     * @memberof DLQRedriveInfoResultResult
     */
    'counts'?: DLQRedriveInfoResultResultCounts;
    /**
     * Error code from failed execution
     * @type {string}
     * @memberof DLQRedriveInfoResultResult
     */
    'error'?: string;
    /**
     * Detailed error message from failed execution
     * @type {string}
     * @memberof DLQRedriveInfoResultResult
     */
    'cause'?: string;
}
/**
 * Message-level totals (from the DistributedMap item counts) for a file redrive, present when resolvable
 * @export
 * @interface DLQRedriveInfoResultResultCounts
 */
export interface DLQRedriveInfoResultResultCounts {
    /**
     * Total messages the redrive attempted
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'total'?: number;
    /**
     * Messages whose batch completed
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'succeeded'?: number;
    /**
     * Messages in batches that failed, aborted or timed out
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'failed'?: number;
    /**
     * Messages that never ran (skipped after the redrive failed)
     * @type {number}
     * @memberof DLQRedriveInfoResultResultCounts
     */
    'pending'?: number;
}
/**
 * 
 * @export
 * @interface DLQRedriveMcmError
 */
export interface DLQRedriveMcmError {
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveMcmError
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveMcmError
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof DLQRedriveMcmError
     */
    'requestId'?: string;
}
/**
 * 
 * @export
 * @interface DashboardEmbedResponse
 */
export interface DashboardEmbedResponse {
    /**
     * The URL for embedding the dashboard
     * @type {string}
     * @memberof DashboardEmbedResponse
     */
    'embedUrl': string;
    /**
     * The request ID for this embed URL generation
     * @type {string}
     * @memberof DashboardEmbedResponse
     */
    'requestId': string;
}
/**
 * 
 * @export
 * @interface DetailsResponse
 */
export interface DetailsResponse {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof DetailsResponse
     */
    'events'?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof DetailsResponse
     */
    'cbes'?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {DetailsResponseFallback}
     * @memberof DetailsResponse
     */
    'fallback'?: DetailsResponseFallback;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailsResponse
     */
    'auids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DetailsResponseFallback
 */
export interface DetailsResponseFallback {
    /**
     * 
     * @type {string}
     * @memberof DetailsResponseFallback
     */
    'originalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsResponseFallback
     */
    'resolvedId'?: string;
}
/**
 * 
 * @export
 * @interface DigitalPaymentDocument
 */
export interface DigitalPaymentDocument {
    /**
     * The top-level document ID
     * @type {string}
     * @memberof DigitalPaymentDocument
     */
    'id': string;
    /**
     * The top-level document version
     * @type {number}
     * @memberof DigitalPaymentDocument
     */
    'version': number;
    /**
     * Discriminator identifying this as a DigitalPaymentDocument
     * @type {string}
     * @memberof DigitalPaymentDocument
     */
    'documentType': DigitalPaymentDocumentDocumentTypeEnum;
    /**
     * 
     * @type {DigitalPaymentDocumentBody}
     * @memberof DigitalPaymentDocument
     */
    'body': DigitalPaymentDocumentBody;
}

export const DigitalPaymentDocumentDocumentTypeEnum = {
    DigitalPaymentDocument: 'DigitalPaymentDocument'
} as const;

export type DigitalPaymentDocumentDocumentTypeEnum = typeof DigitalPaymentDocumentDocumentTypeEnum[keyof typeof DigitalPaymentDocumentDocumentTypeEnum];

/**
 * 
 * @export
 * @interface DigitalPaymentDocumentBody
 */
export interface DigitalPaymentDocumentBody {
    /**
     * 
     * @type {DigitalPaymentDocumentHeader}
     * @memberof DigitalPaymentDocumentBody
     */
    'header': DigitalPaymentDocumentHeader;
    /**
     * 
     * @type {DigitalPaymentDocumentBody}
     * @memberof DigitalPaymentDocumentBody
     */
    'body': DigitalPaymentDocumentBody;
    /**
     * 
     * @type {DigitalPaymentDocumentMetadata}
     * @memberof DigitalPaymentDocumentBody
     */
    'metadata': DigitalPaymentDocumentMetadata;
}
/**
 * 
 * @export
 * @interface DigitalPaymentDocumentHeader
 */
export interface DigitalPaymentDocumentHeader {
    /**
     * The document ID
     * @type {string}
     * @memberof DigitalPaymentDocumentHeader
     */
    'id'?: string;
    /**
     * The document version
     * @type {number}
     * @memberof DigitalPaymentDocumentHeader
     */
    'version'?: number;
    /**
     * The marketplace ID
     * @type {string}
     * @memberof DigitalPaymentDocumentHeader
     */
    'marketplaceId'?: string;
    /**
     * The transaction date
     * @type {string}
     * @memberof DigitalPaymentDocumentHeader
     */
    'transactionDate'?: string;
}
/**
 * 
 * @export
 * @interface DigitalPaymentDocumentMetadata
 */
export interface DigitalPaymentDocumentMetadata {
    /**
     * Additional attributes map
     * @type {{ [key: string]: string; }}
     * @memberof DigitalPaymentDocumentMetadata
     */
    'attributes'?: { [key: string]: string; };
    /**
     * Events map
     * @type {{ [key: string]: any; }}
     * @memberof DigitalPaymentDocumentMetadata
     */
    'events'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface DownloadS3FileResponse
 */
export interface DownloadS3FileResponse {
    /**
     * Pre-Signed url for S3 file
     * @type {string}
     * @memberof DownloadS3FileResponse
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'orderId'?: string;
}
/**
 * 
 * @export
 * @interface FinancialAmountRow
 */
export interface FinancialAmountRow {
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'sourceAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'sourceCurr'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'gammaUslAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'gammaUslCurr'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'prodUslAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialAmountRow
     */
    'prodUslCurr'?: string;
}
/**
 * 
 * @export
 * @interface GetDLQRedriveUploadUrl200Response
 */
export interface GetDLQRedriveUploadUrl200Response {
    /**
     * Presigned URL for file upload
     * @type {string}
     * @memberof GetDLQRedriveUploadUrl200Response
     */
    'uploadUrl'?: string;
    /**
     * S3 URI of the file after upload
     * @type {string}
     * @memberof GetDLQRedriveUploadUrl200Response
     */
    's3Uri'?: string;
}
/**
 * 
 * @export
 * @interface GetDLQRedrivesInfo200ResponseInner
 */
export interface GetDLQRedrivesInfo200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetDLQRedrivesInfo200ResponseInner
     */
    'executionArn': string;
    /**
     * 
     * @type {string}
     * @memberof GetDLQRedrivesInfo200ResponseInner
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetDLQRedrivesInfo200ResponseInner
     */
    'startDate': string;
}
/**
 * 
 * @export
 * @interface GetRedriveInfo200Response
 */
export interface GetRedriveInfo200Response {
    /**
     * 
     * @type {Array<GetRedriveInfo200ResponseExecutionsInner>}
     * @memberof GetRedriveInfo200Response
     */
    'executions'?: Array<GetRedriveInfo200ResponseExecutionsInner>;
}
/**
 * 
 * @export
 * @interface GetRedriveInfo200ResponseExecutionsInner
 */
export interface GetRedriveInfo200ResponseExecutionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'executionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'stage'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'orders'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'executor'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetRedriveInfo200ResponseExecutionsInner
     */
    'timestamp'?: number;
}
/**
 * 
 * @export
 * @interface GetRedriveOrders200Response
 */
export interface GetRedriveOrders200Response {
    /**
     * Presigned URL to download the orders CSV file
     * @type {string}
     * @memberof GetRedriveOrders200Response
     */
    'downloadUrl'?: string;
    /**
     * User who executed the redrive
     * @type {string}
     * @memberof GetRedriveOrders200Response
     */
    'executor'?: string;
    /**
     * Execution status of the redrive
     * @type {string}
     * @memberof GetRedriveOrders200Response
     */
    'status'?: string;
    /**
     * Epoch seconds when the redrive was requested
     * @type {number}
     * @memberof GetRedriveOrders200Response
     */
    'timestamp'?: number;
    /**
     * Number of orders in the redrive
     * @type {number}
     * @memberof GetRedriveOrders200Response
     */
    'orders'?: number;
}
/**
 * 
 * @export
 * @interface HerdErrorDetail
 */
export interface HerdErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof HerdErrorDetail
     */
    'stackTrace'?: string;
}
/**
 * 
 * @export
 * @interface ListProjects200Response
 */
export interface ListProjects200Response {
    /**
     * 
     * @type {Array<Project>}
     * @memberof ListProjects200Response
     */
    'projects'?: Array<Project>;
}
/**
 * 
 * @export
 * @interface MatchSetEntry
 */
export interface MatchSetEntry {
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'matchKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'matchSetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'state'?: MatchSetEntryStateEnum;
    /**
     * 
     * @type {MatchSetEntryAmount}
     * @memberof MatchSetEntry
     */
    'amount'?: MatchSetEntryAmount;
    /**
     * 
     * @type {number}
     * @memberof MatchSetEntry
     */
    'numCredits'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchSetEntry
     */
    'numDebits'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'accountingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntry
     */
    'matchKeyType'?: string;
}

export const MatchSetEntryStateEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED',
    Partial: 'PARTIAL',
    Pending: 'PENDING',
    Unknown: 'UNKNOWN'
} as const;

export type MatchSetEntryStateEnum = typeof MatchSetEntryStateEnum[keyof typeof MatchSetEntryStateEnum];

/**
 * 
 * @export
 * @interface MatchSetEntryAmount
 */
export interface MatchSetEntryAmount {
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'currencyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'creditValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSetEntryAmount
     */
    'debitValue'?: string;
}
/**
 * 
 * @export
 * @interface MatchSetResponse
 */
export interface MatchSetResponse {
    /**
     * 
     * @type {Array<MatchSetEntry>}
     * @memberof MatchSetResponse
     */
    'matchSets'?: Array<MatchSetEntry>;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface OrderContentsResponse
 */
export interface OrderContentsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OrderContentsResponse
     */
    'found'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderContentsResponse
     */
    'eventVersion'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderContentsResponse
     */
    'totalProducts'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderContentsResponse
     */
    'realProductCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderContentsResponse
     */
    'placeholderCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderContentsResponse
     */
    'placeholderProductIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderContentsResponse
     */
    'realProductIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderContentsResponse
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface OrderRedriveInfoResult
 */
export interface OrderRedriveInfoResult {
    /**
     * The ID of the redrive execution
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'executionId'?: string;
    /**
     * The number of orders redriven
     * @type {number}
     * @memberof OrderRedriveInfoResult
     */
    'orders'?: number;
    /**
     * The name of the executor
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'executor'?: string;
    /**
     * The stage that the redrive was executed on
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'stage'?: string;
    /**
     * The status of the Redrive (was it successful, is it still executing, etc.)
     * @type {string}
     * @memberof OrderRedriveInfoResult
     */
    'status'?: string;
    /**
     * When was the redrive executed
     * @type {number}
     * @memberof OrderRedriveInfoResult
     */
    'timestamp'?: number;
}
/**
 * The current status of a payment
 * @export
 * @enum {string}
 */

export const PaymentStatus = {
    PaymentInitiated: 'PaymentInitiated',
    PaymentRejected: 'PaymentRejected',
    PaymentFxReceived: 'PaymentFXReceived'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];

/**
 * 
 * @export
 * @interface PostDLQRedriveInfoRequest
 */
export interface PostDLQRedriveInfoRequest {
    /**
     * Array of DLQ primary keys (pk field from DLQItem, NOT message_id)
     * @type {Array<string>}
     * @memberof PostDLQRedriveInfoRequest
     */
    'messageIds'?: Array<string>;
    /**
     * S3 URI of uploaded CSV file containing message IDs
     * @type {string}
     * @memberof PostDLQRedriveInfoRequest
     */
    'messageIdsS3Uri'?: string;
    /**
     * ETag of the uploaded S3 file for validation
     * @type {string}
     * @memberof PostDLQRedriveInfoRequest
     */
    'messageIdsS3Etag'?: string;
    /**
     * MCM ID (required when deleteWithoutRedriving is true)
     * @type {string}
     * @memberof PostDLQRedriveInfoRequest
     */
    'mcmId'?: string;
    /**
     * If true, validate without executing
     * @type {boolean}
     * @memberof PostDLQRedriveInfoRequest
     */
    'dryRun'?: boolean;
    /**
     * If true, delete messages without redriving (requires mcmId)
     * @type {boolean}
     * @memberof PostDLQRedriveInfoRequest
     */
    'deleteWithoutRedriving'?: boolean;
}
/**
 * 
 * @export
 * @interface PostDLQRedriveMcm201Response
 */
export interface PostDLQRedriveMcm201Response {
    /**
     * 
     * @type {string}
     * @memberof PostDLQRedriveMcm201Response
     */
    'mcmId': string;
    /**
     * 
     * @type {string}
     * @memberof PostDLQRedriveMcm201Response
     */
    'mcmUrl': string;
    /**
     * Warning when the Draft MCM was created but its description could not be verified
     * @type {string}
     * @memberof PostDLQRedriveMcm201Response
     */
    'warning'?: string;
}
/**
 * 
 * @export
 * @interface PostDLQRedriveMcmRequest
 */
export interface PostDLQRedriveMcmRequest {
    /**
     * DLQ primary keys for the manual-pk path
     * @type {Array<string>}
     * @memberof PostDLQRedriveMcmRequest
     */
    'messageIds'?: Array<string>;
    /**
     * S3 URI of the already-uploaded DLQ primary-key CSV
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'messageIdsS3Uri'?: string;
    /**
     * ETag of the already-uploaded CSV
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'messageIdsS3Etag'?: string;
    /**
     * Optional SIM issue URL included in the MCM description
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'simLink'?: string;
    /**
     * Optional Athena query included in the MCM description for audit context
     * @type {string}
     * @memberof PostDLQRedriveMcmRequest
     */
    'athenaQuery'?: string;
}
/**
 * 
 * @export
 * @interface PostPaymentRedriveBulkRequest
 */
export interface PostPaymentRedriveBulkRequest {
    /**
     * S3 URI of the uploaded CSV file. Use the s3Uri value returned by GET /payment-redrive-upload-url to ensure the fileName is resolved correctly by the step function. 
     * @type {string}
     * @memberof PostPaymentRedriveBulkRequest
     */
    's3_uri': string;
}
/**
 * 
 * @export
 * @interface PostPaymentRedriveRequest
 */
export interface PostPaymentRedriveRequest {
    /**
     * Primary key of the cost document to redrive
     * @type {string}
     * @memberof PostPaymentRedriveRequest
     */
    'pk': string;
}
/**
 * 
 * @export
 * @interface PostRedriveInfo202Response
 */
export interface PostRedriveInfo202Response {
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'executionArn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'executionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveInfo202Response
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface PostRedriveInfoRequest
 */
export interface PostRedriveInfoRequest {
    /**
     * S3 URI of the uploaded CSV file. Use the s3Uri value returned by GET /redrive-upload-url to ensure the fileName is resolved correctly by the step function. 
     * @type {string}
     * @memberof PostRedriveInfoRequest
     */
    's3_uri': string;
}
/**
 * 
 * @export
 * @interface PostRedriveOrder202Response
 */
export interface PostRedriveOrder202Response {
    /**
     * 
     * @type {string}
     * @memberof PostRedriveOrder202Response
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveOrder202Response
     */
    'executionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostRedriveOrder202Response
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface PostRedriveOrderRequest
 */
export interface PostRedriveOrderRequest {
    /**
     * The single transaction or order ID to redrive
     * @type {string}
     * @memberof PostRedriveOrderRequest
     */
    'orderId': string;
}
/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'lastModifiedBy': string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    'lastModified': string;
    /**
     * 
     * @type {Array<ProjectTransaction>}
     * @memberof Project
     */
    'transactions': Array<ProjectTransaction>;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'version': number;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    'isArchived': boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Project
     */
    'metadata'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ProjectCreate
 */
export interface ProjectCreate {
    /**
     * 
     * @type {string}
     * @memberof ProjectCreate
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCreate
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProjectCreate
     */
    'metadata'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ProjectTransaction
 */
export interface ProjectTransaction {
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'txnStatus': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'uatStatus': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'assignedTo': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'addedBy': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTransaction
     */
    'addedAt': string;
}
/**
 * 
 * @export
 * @interface ProjectUpdate
 */
export interface ProjectUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProjectUpdate
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectUpdate
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProjectUpdate
     */
    'metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ProjectUpdate
     */
    'isArchived'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectUpdate
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface ProjectValidationCase
 */
export interface ProjectValidationCase {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'taskGid': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'taskName': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'taskUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'orderId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'verdict': ProjectValidationCaseVerdictEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'assessment': ProjectValidationCaseAssessmentEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectValidationCase
     */
    'retestRecommended': boolean;
    /**
     * 
     * @type {{ [key: string]: ProjectValidationFieldResult; }}
     * @memberof ProjectValidationCase
     */
    'fields': { [key: string]: ProjectValidationFieldResult; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectValidationCase
     */
    'scopeErrors': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectValidationCase
     */
    'sourceRefs': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'validatorVersion': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationCase
     */
    'actionCatalogVersion': string;
}

export const ProjectValidationCaseVerdictEnum = {
    MatchesScope: 'matches_scope',
    Mismatch: 'mismatch',
    NeedsReview: 'needs_review'
} as const;

export type ProjectValidationCaseVerdictEnum = typeof ProjectValidationCaseVerdictEnum[keyof typeof ProjectValidationCaseVerdictEnum];
export const ProjectValidationCaseAssessmentEnum = {
    MatchesScope: 'matches_scope',
    WrongOrder: 'wrong_order',
    AccountingMismatch: 'accounting_mismatch',
    CannotVerify: 'cannot_verify',
    IncompleteScope: 'incomplete_scope'
} as const;

export type ProjectValidationCaseAssessmentEnum = typeof ProjectValidationCaseAssessmentEnum[keyof typeof ProjectValidationCaseAssessmentEnum];

/**
 * 
 * @export
 * @interface ProjectValidationCounts
 */
export interface ProjectValidationCounts {
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'matchesScope': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'mismatch': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'needsReview': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationCounts
     */
    'incomplete': number;
}
/**
 * 
 * @export
 * @interface ProjectValidationFieldResult
 */
export interface ProjectValidationFieldResult {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationFieldResult
     */
    'verdict': ProjectValidationFieldResultVerdictEnum;
    /**
     * Bounded scalar or string-list expected value
     * @type {any}
     * @memberof ProjectValidationFieldResult
     */
    'expected'?: any | null;
    /**
     * Bounded scalar or string-list observed value
     * @type {any}
     * @memberof ProjectValidationFieldResult
     */
    'observed'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationFieldResult
     */
    'reasonCode': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationFieldResult
     */
    'reason': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectValidationFieldResult
     */
    'evidenceRefs': Array<string>;
}

export const ProjectValidationFieldResultVerdictEnum = {
    Match: 'match',
    Mismatch: 'mismatch',
    NotVerifiable: 'not_verifiable',
    NotApplicable: 'not_applicable'
} as const;

export type ProjectValidationFieldResultVerdictEnum = typeof ProjectValidationFieldResultVerdictEnum[keyof typeof ProjectValidationFieldResultVerdictEnum];

/**
 * 
 * @export
 * @interface ProjectValidationProgress
 */
export interface ProjectValidationProgress {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationProgress
     */
    'phase': ProjectValidationProgressPhaseEnum;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationProgress
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationProgress
     */
    'completed': number;
}

export const ProjectValidationProgressPhaseEnum = {
    Queued: 'queued',
    Loading: 'loading',
    Validating: 'validating'
} as const;

export type ProjectValidationProgressPhaseEnum = typeof ProjectValidationProgressPhaseEnum[keyof typeof ProjectValidationProgressPhaseEnum];

/**
 * 
 * @export
 * @interface ProjectValidationResult
 */
export interface ProjectValidationResult {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationResult
     */
    'schemaVersion': ProjectValidationResultSchemaVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationResult
     */
    'projectGid': string;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ProjectValidationResult
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationResult
     */
    'sourceReadAt': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationResult
     */
    'sourceTaskCount': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationResult
     */
    'durationMs': number;
    /**
     * 
     * @type {ProjectValidationCounts}
     * @memberof ProjectValidationResult
     */
    'counts': ProjectValidationCounts;
    /**
     * 
     * @type {Array<ProjectValidationCase>}
     * @memberof ProjectValidationResult
     */
    'cases': Array<ProjectValidationCase>;
}

export const ProjectValidationResultSchemaVersionEnum = {
    _1: '1'
} as const;

export type ProjectValidationResultSchemaVersionEnum = typeof ProjectValidationResultSchemaVersionEnum[keyof typeof ProjectValidationResultSchemaVersionEnum];

/**
 * 
 * @export
 * @interface ProjectValidationRunSummary
 */
export interface ProjectValidationRunSummary {
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'runId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'status': ProjectValidationRunSummaryStatusEnum;
    /**
     * 
     * @type {ProjectValidationStage}
     * @memberof ProjectValidationRunSummary
     */
    'stage': ProjectValidationStage;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'completedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'sourceReadAt': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationRunSummary
     */
    'sourceTaskCount': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectValidationRunSummary
     */
    'durationMs': number;
    /**
     * 
     * @type {string}
     * @memberof ProjectValidationRunSummary
     */
    'asanaProjectGid': string;
    /**
     * 
     * @type {ProjectValidationCounts}
     * @memberof ProjectValidationRunSummary
     */
    'counts': ProjectValidationCounts;
}

export const ProjectValidationRunSummaryStatusEnum = {
    Completed: 'completed'
} as const;

export type ProjectValidationRunSummaryStatusEnum = typeof ProjectValidationRunSummaryStatusEnum[keyof typeof ProjectValidationRunSummaryStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectValidationStage = {
    Beta: 'beta',
    Gamma: 'gamma',
    Prod: 'prod'
} as const;

export type ProjectValidationStage = typeof ProjectValidationStage[keyof typeof ProjectValidationStage];

/**
 * 
 * @export
 * @interface PublishMockAcadiaInvoice202Response
 */
export interface PublishMockAcadiaInvoice202Response {
    /**
     * 
     * @type {string}
     * @memberof PublishMockAcadiaInvoice202Response
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishMockAcadiaInvoice202Response
     */
    'executionArn'?: string;
}
/**
 * 
 * @export
 * @interface PublishMockAcadiaInvoiceRequest
 */
export interface PublishMockAcadiaInvoiceRequest {
    /**
     * paymentId for the invoice
     * @type {string}
     * @memberof PublishMockAcadiaInvoiceRequest
     */
    'paymentId': string;
    /**
     * paymentDate for the invoice
     * @type {string}
     * @memberof PublishMockAcadiaInvoiceRequest
     */
    'paymentDate': string;
}
/**
 * 
 * @export
 * @interface RavenChatUatAnalysisRequest
 */
export interface RavenChatUatAnalysisRequest {
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisRequest
     */
    'transactionId': string;
    /**
     * 
     * @type {number}
     * @memberof RavenChatUatAnalysisRequest
     */
    'testTimestamp': number;
    /**
     * 
     * @type {boolean}
     * @memberof RavenChatUatAnalysisRequest
     */
    'expectedPassed': boolean;
}
/**
 * 
 * @export
 * @interface RavenChatUatAnalysisResponse
 */
export interface RavenChatUatAnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisResponse
     */
    'analysisStatus': RavenChatUatAnalysisResponseAnalysisStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RavenChatUatAnalysisResponse
     */
    'analysis'?: string;
}

export const RavenChatUatAnalysisResponseAnalysisStatusEnum = {
    Pending: 'PENDING',
    Complete: 'COMPLETE',
    Unavailable: 'UNAVAILABLE'
} as const;

export type RavenChatUatAnalysisResponseAnalysisStatusEnum = typeof RavenChatUatAnalysisResponseAnalysisStatusEnum[keyof typeof RavenChatUatAnalysisResponseAnalysisStatusEnum];

/**
 * 
 * @export
 * @interface RecentTransactionsResponse
 */
export interface RecentTransactionsResponse {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof RecentTransactionsResponse
     */
    'transactions': Array<Transaction>;
    /**
     * Timestamp to use for fetching the next page of results
     * @type {number}
     * @memberof RecentTransactionsResponse
     */
    'nextPageTimestamp'?: number;
    /**
     * The CloudWatch Logs Insights query that was executed
     * @type {string}
     * @memberof RecentTransactionsResponse
     */
    'executedQuery'?: string;
}
/**
 * 
 * @export
 * @interface RetryDLQRedriveRequest
 */
export interface RetryDLQRedriveRequest {
    /**
     * ARN of the execution to retry (its input is reused verbatim)
     * @type {string}
     * @memberof RetryDLQRedriveRequest
     */
    'executionArn': string;
}
/**
 * 
 * @export
 * @interface ShadowTestClassificationsResponse
 */
export interface ShadowTestClassificationsResponse {
    /**
     * 
     * @type {Array<ClassificationEntry>}
     * @memberof ShadowTestClassificationsResponse
     */
    'classifications': Array<ClassificationEntry>;
}
/**
 * 
 * @export
 * @interface ShadowTestDiscrepancy
 */
export interface ShadowTestDiscrepancy {
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'field'?: string;
    /**
     * Component GTI for bundle orders
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'gti'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'usecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'prodValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'gammaValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'intent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestDiscrepancy
     */
    'passed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestDiscrepancy
     */
    'jemValue'?: string;
}
/**
 * 
 * @export
 * @interface ShadowTestLine
 */
export interface ShadowTestLine {
    /**
     * MATCHED, GAMMA_UNIQUE, PROD_UNIQUE, or JEM_UNIQUE
     * @type {string}
     * @memberof ShadowTestLine
     */
    'type'?: string;
    /**
     * e.g. gamma, prod, gamma+prod, gamma+jem
     * @type {string}
     * @memberof ShadowTestLine
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestLine
     */
    'passed'?: boolean;
    /**
     * Component GTI for bundle orders
     * @type {string}
     * @memberof ShadowTestLine
     */
    'gti'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'usecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'journalSide'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'costCenter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'project'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'productLine'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'glLineDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'functionalAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'localAmount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'functionalCurrency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'localCurrency'?: string;
    /**
     * Deprecated: equal to functionalCurrency. Read functionalCurrency/localCurrency instead.
     * @type {string}
     * @memberof ShadowTestLine
     * @deprecated
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'setOfBooks'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'matchKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestLine
     */
    'intent'?: string;
}
/**
 * 
 * @export
 * @interface ShadowTestMatchSet
 */
export interface ShadowTestMatchSet {
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'matchKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'accountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestMatchSet
     */
    'classification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestMatchSet
     */
    'passed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestMatchSet
     */
    'closed'?: boolean;
}
/**
 * 
 * @export
 * @interface ShadowTestResponse
 */
export interface ShadowTestResponse {
    /**
     * Status message of the shadow test initiation
     * @type {string}
     * @memberof ShadowTestResponse
     */
    'message': string;
    /**
     * Number of orders included in the shadow test
     * @type {number}
     * @memberof ShadowTestResponse
     */
    'transactionsCount': number;
}
/**
 * 
 * @export
 * @interface ShadowTestResultResponse
 */
export interface ShadowTestResultResponse {
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'transactionId': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'passed': boolean;
    /**
     * Epoch millis when the test ran
     * @type {number}
     * @memberof ShadowTestResultResponse
     */
    'testTimestamp': number;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'glProductGroup'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'paymentProvider'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'orderDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'isPromo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'isBundle'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'prodRevenueUsecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'gammaRevenueUsecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'prodRoyaltyUsecase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowTestResultResponse
     */
    'gammaRoyaltyUsecase'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowTestResultResponse
     */
    'prodUsecases'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowTestResultResponse
     */
    'gammaUsecases'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowTestResultResponse
     */
    'jemUsecases'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ShadowTestResultResponse
     */
    'totalProdLines'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShadowTestResultResponse
     */
    'totalGammaLines'?: number;
    /**
     * Map of reference key names to values (order_id, auid, subscription_id, etc.)
     * @type {{ [key: string]: string; }}
     * @memberof ShadowTestResultResponse
     */
    'referenceKeys'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'matchedLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'gammaUniqueLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'prodUniqueLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestLine>}
     * @memberof ShadowTestResultResponse
     */
    'jemUniqueLines'?: Array<ShadowTestLine>;
    /**
     * 
     * @type {Array<ShadowTestDiscrepancy>}
     * @memberof ShadowTestResultResponse
     */
    'discrepancies'?: Array<ShadowTestDiscrepancy>;
    /**
     * 
     * @type {Array<ShadowTestMatchSet>}
     * @memberof ShadowTestResultResponse
     */
    'matchSets'?: Array<ShadowTestMatchSet>;
    /**
     * Account balance pivot for gamma: glLineDescription -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof ShadowTestResultResponse
     */
    'gammaPivot'?: { [key: string]: { [key: string]: number; }; };
    /**
     * Account balance pivot for prod: glLineDescription -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof ShadowTestResultResponse
     */
    'prodPivot'?: { [key: string]: { [key: string]: number; }; };
    /**
     * Bundle orders only. Per-component gamma pivot: glLineDescription -> GTI -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: { [key: string]: number; }; }; }}
     * @memberof ShadowTestResultResponse
     */
    'gammaPivotByProduct'?: { [key: string]: { [key: string]: { [key: string]: number; }; }; };
    /**
     * Bundle orders only. Per-component prod pivot: glLineDescription -> GTI -> accountNumber-companyCode -> signed amount
     * @type {{ [key: string]: { [key: string]: { [key: string]: number; }; }; }}
     * @memberof ShadowTestResultResponse
     */
    'prodPivotByProduct'?: { [key: string]: { [key: string]: { [key: string]: number; }; }; };
    /**
     * Bundle orders only. Split validation rows: component GTI (plus a Total Bundle Level entry) -> cell name -> value
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ShadowTestResultResponse
     */
    'bundleAllocation'?: { [key: string]: { [key: string]: string; }; };
    /**
     * Whether every populated bundle allocation cell matched
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'bundleAllocationPassed'?: boolean;
    /**
     * Whether the order payment total equals the summed component SSPs
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'bundleAllocationPaymentIntegrityPassed'?: boolean;
    /**
     * Financial amounts validation rows: key -> FinancialAmountRow
     * @type {{ [key: string]: FinancialAmountRow; }}
     * @memberof ShadowTestResultResponse
     */
    'financialAmounts'?: { [key: string]: FinancialAmountRow; };
    /**
     * Whether all source amounts match the USL amounts
     * @type {boolean}
     * @memberof ShadowTestResultResponse
     */
    'sourceAmountCheckPassed'?: boolean;
}
/**
 * environment name
 * @export
 * @enum {string}
 */

export const Stage = {
    Beta: 'Beta',
    Gamma: 'Gamma',
    Prod: 'Prod'
} as const;

export type Stage = typeof Stage[keyof typeof Stage];

/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * Either AUID or OrderId depending on GL code
     * @type {string}
     * @memberof Transaction
     */
    'id': string;
    /**
     * 
     * @type {Stage}
     * @memberof Transaction
     */
    'stage': Stage;
    /**
     * Country code (e.g., US, GB, DE)
     * @type {string}
     * @memberof Transaction
     */
    'country': string;
    /**
     * GL code (e.g., 318, 613)
     * @type {string}
     * @memberof Transaction
     */
    'gl': string;
    /**
     * Time when the transaction was processed
     * @type {string}
     * @memberof Transaction
     */
    'processedTime': string;
    /**
     * Simplified transaction type
     * @type {string}
     * @memberof Transaction
     */
    'usecase': string;
    /**
     * Payment method used for the transaction
     * @type {string}
     * @memberof Transaction
     */
    'paymentMethod': string;
    /**
     * Consumption Type for the transaction
     * @type {string}
     * @memberof Transaction
     */
    'consumptionType': string;
}
/**
 * 
 * @export
 * @interface TransactionCreate
 */
export interface TransactionCreate {
    /**
     * 
     * @type {string}
     * @memberof TransactionCreate
     */
    'transactionId': string;
    /**
     * 
     * @type {string}
     * @memberof TransactionCreate
     */
    'assignedTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionCreate
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface TransactionUpdate
 */
export interface TransactionUpdate {
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdate
     */
    'txnStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdate
     */
    'uatStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionUpdate
     */
    'assignedTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionUpdate
     */
    'version': number;
}

/**
 * CbesApi - axios parameter creator
 * @export
 */
export const CbesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Rollup of CBE counts by usecase, operation, and publish status
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbeSummary: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getCbeSummary', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getCbeSummary', 'orderId', orderId)
            const localVarPath = `/cbe-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of cbe\'s
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbes: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getCbes', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getCbes', 'orderId', orderId)
            const localVarPath = `/cbes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDetails', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getDetails', 'orderId', orderId)
            const localVarPath = `/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
         * @param {Stage} stage environment name
         * @param {string} objectId The CBE\&#39;s Herd execution objectId
         * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHerdErrorDetail: async (stage: Stage, objectId: string, realm: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getHerdErrorDetail', 'stage', stage)
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getHerdErrorDetail', 'objectId', objectId)
            // verify required parameter 'realm' is not null or undefined
            assertParamExists('getHerdErrorDetail', 'realm', realm)
            const localVarPath = `/herd-error-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['objectId'] = objectId;
            }

            if (realm !== undefined) {
                localVarQueryParameter['realm'] = realm;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CbesApi - functional programming interface
 * @export
 */
export const CbesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CbesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Rollup of CBE counts by usecase, operation, and publish status
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCbeSummary(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CbeSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCbeSummary(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of cbe\'s
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCbes(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Cbe>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCbes(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
         * @param {Stage} stage environment name
         * @param {string} objectId The CBE\&#39;s Herd execution objectId
         * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHerdErrorDetail(stage: Stage, objectId: string, realm: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HerdErrorDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHerdErrorDetail(stage, objectId, realm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CbesApi - factory interface
 * @export
 */
export const CbesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CbesApiFp(configuration)
    return {
        /**
         * 
         * @summary Rollup of CBE counts by usecase, operation, and publish status
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbeSummary(stage: Stage, orderId: string, options?: any): AxiosPromise<CbeSummaryResponse> {
            return localVarFp.getCbeSummary(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of cbe\'s
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCbes(stage: Stage, orderId: string, options?: any): AxiosPromise<Array<Cbe>> {
            return localVarFp.getCbes(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(stage: Stage, orderId: string, options?: any): AxiosPromise<DetailsResponse> {
            return localVarFp.getDetails(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
         * @param {Stage} stage environment name
         * @param {string} objectId The CBE\&#39;s Herd execution objectId
         * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHerdErrorDetail(stage: Stage, objectId: string, realm: string, options?: any): AxiosPromise<HerdErrorDetail> {
            return localVarFp.getHerdErrorDetail(stage, objectId, realm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CbesApi - object-oriented interface
 * @export
 * @class CbesApi
 * @extends {BaseAPI}
 */
export class CbesApi extends BaseAPI {
    /**
     * 
     * @summary Rollup of CBE counts by usecase, operation, and publish status
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getCbeSummary(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getCbeSummary(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of cbe\'s
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getCbes(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getCbes(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of CBEs and events
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getDetails(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Full Herd/USL failure detail (stack trace) for a single errored FLARE CBE
     * @param {Stage} stage environment name
     * @param {string} objectId The CBE\&#39;s Herd execution objectId
     * @param {string} realm The CBE\&#39;s accounting realm (selects the regional ORCA gateway)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CbesApi
     */
    public getHerdErrorDetail(stage: Stage, objectId: string, realm: string, options?: AxiosRequestConfig) {
        return CbesApiFp(this.configuration).getHerdErrorDetail(stage, objectId, realm, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat: async (stage: Stage, chatRequest: ChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chat', 'stage', stage)
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chat', 'chatRequest', chatRequest)
            const localVarPath = `/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a chat turn in the background and return a job id to poll
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAsync: async (stage: Stage, chatRequest: ChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chatAsync', 'stage', stage)
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chatAsync', 'chatRequest', chatRequest)
            const localVarPath = `/chat-async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suggest short follow-up questions for the last chat Q&A
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatFollowups: async (stage: Stage, chatRequest: ChatRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chatFollowups', 'stage', stage)
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chatFollowups', 'chatRequest', chatRequest)
            const localVarPath = `/chat-followups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll an async chat job for its progress and, once done, its answer
         * @param {Stage} stage environment name
         * @param {string} jobId Job id returned by chat-async
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStatus: async (stage: Stage, jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('chatStatus', 'stage', stage)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('chatStatus', 'jobId', jobId)
            const localVarPath = `/chat-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chat(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chat(stage, chatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a chat turn in the background and return a job id to poll
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatAsync(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatAsyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatAsync(stage, chatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Suggest short follow-up questions for the last chat Q&A
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatFollowups(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatFollowupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatFollowups(stage, chatRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Poll an async chat job for its progress and, once done, its answer
         * @param {Stage} stage environment name
         * @param {string} jobId Job id returned by chat-async
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatStatus(stage: Stage, jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatStatus(stage, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat(stage: Stage, chatRequest: ChatRequest, options?: any): AxiosPromise<ChatResponse> {
            return localVarFp.chat(stage, chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a chat turn in the background and return a job id to poll
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAsync(stage: Stage, chatRequest: ChatRequest, options?: any): AxiosPromise<ChatAsyncResponse> {
            return localVarFp.chatAsync(stage, chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suggest short follow-up questions for the last chat Q&A
         * @param {Stage} stage environment name
         * @param {ChatRequest} chatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatFollowups(stage: Stage, chatRequest: ChatRequest, options?: any): AxiosPromise<ChatFollowupsResponse> {
            return localVarFp.chatFollowups(stage, chatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll an async chat job for its progress and, once done, its answer
         * @param {Stage} stage environment name
         * @param {string} jobId Job id returned by chat-async
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStatus(stage: Stage, jobId: string, options?: any): AxiosPromise<ChatStatusResponse> {
            return localVarFp.chatStatus(stage, jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @summary Ask questions about a transaction using an AI assistant grounded in Lusca data
     * @param {Stage} stage environment name
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chat(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chat(stage, chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a chat turn in the background and return a job id to poll
     * @param {Stage} stage environment name
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatAsync(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatAsync(stage, chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suggest short follow-up questions for the last chat Q&A
     * @param {Stage} stage environment name
     * @param {ChatRequest} chatRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatFollowups(stage: Stage, chatRequest: ChatRequest, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatFollowups(stage, chatRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll an async chat job for its progress and, once done, its answer
     * @param {Stage} stage environment name
     * @param {string} jobId Job id returned by chat-async
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatStatus(stage: Stage, jobId: string, options?: AxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatStatus(stage, jobId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ChatUatApi - axios parameter creator
 * @export
 */
export const ChatUatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Begin per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beginChatUatAsanaAuthorization: async (asanaAuthorizationRequest: AsanaAuthorizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaAuthorizationRequest' is not null or undefined
            assertParamExists('beginChatUatAsanaAuthorization', 'asanaAuthorizationRequest', asanaAuthorizationRequest)
            const localVarPath = `/chat-uat/asana/authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaAuthorizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChatUatAsanaAuthorization: async (asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaAuthorizationCompleteRequest' is not null or undefined
            assertParamExists('completeChatUatAsanaAuthorization', 'asanaAuthorizationCompleteRequest', asanaAuthorizationCompleteRequest)
            const localVarPath = `/chat-uat/asana/authorization/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaAuthorizationCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove the linked Asana scope while retaining validation history
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatUatAsanaScope: async (version: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('deleteChatUatAsanaScope', 'version', version)
            const localVarPath = `/chat-uat/validation/asana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return bounded order content facts for ChatUAT validation
         * @param {string} orderId 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatContentFacts: async (orderId: string, stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getChatUatContentFacts', 'orderId', orderId)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getChatUatContentFacts', 'stage', stage)
            const localVarPath = `/iam/chat-uat/content-facts/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a long-running ChatUAT turn
         * @param {string} conversationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatJob: async (conversationId: string, jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getChatUatJob', 'conversationId', conversationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getChatUatJob', 'jobId', jobId)
            const localVarPath = `/chat-uat/jobs/{conversationId}/{jobId}`
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll a deterministic Asana-scope validation job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationJob: async (jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getChatUatScopeValidationJob', 'jobId', jobId)
            const localVarPath = `/chat-uat/validation/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one validation run and all bounded case results
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationRun: async (runId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getChatUatScopeValidationRun', 'runId', runId)
            const localVarPath = `/chat-uat/validation/runs/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the authenticated user\'s Asana validation state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatValidationState: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat-uat/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a readable Asana project
         * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewChatUatAsanaScope: async (asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaLinkPreviewRequest' is not null or undefined
            assertParamExists('previewChatUatAsanaScope', 'asanaLinkPreviewRequest', asanaLinkPreviewRequest)
            const localVarPath = `/chat-uat/validation/asana/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaLinkPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a long-running ChatUAT turn
         * @param {ChatUatJobRequest} chatUatJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatJob: async (chatUatJobRequest: ChatUatJobRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatUatJobRequest' is not null or undefined
            assertParamExists('startChatUatJob', 'chatUatJobRequest', chatUatJobRequest)
            const localVarPath = `/chat-uat/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUatJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start deterministic validation of the linked Asana test cases
         * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatScopeValidation: async (chatUatValidationStartRequest: ChatUatValidationStartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatUatValidationStartRequest' is not null or undefined
            assertParamExists('startChatUatScopeValidation', 'chatUatValidationStartRequest', chatUatValidationStartRequest)
            const localVarPath = `/chat-uat/validation/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUatValidationStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or read automated ChatUAT analysis for a completed Raven result
         * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRavenChatUatAnalysis: async (ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ravenChatUatAnalysisRequest' is not null or undefined
            assertParamExists('startRavenChatUatAnalysis', 'ravenChatUatAnalysisRequest', ravenChatUatAnalysisRequest)
            const localVarPath = `/iam/chat-uat/raven-analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ravenChatUatAnalysisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit feedback for a terminal ChatUAT response
         * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChatUatFeedback: async (chatUatFeedbackRequest: ChatUatFeedbackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatUatFeedbackRequest' is not null or undefined
            assertParamExists('submitChatUatFeedback', 'chatUatFeedbackRequest', chatUatFeedbackRequest)
            const localVarPath = `/chat-uat/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUatFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save the Asana project used by ChatUAT
         * @param {AsanaLinkUpdate} asanaLinkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatUatAsanaScope: async (asanaLinkUpdate: AsanaLinkUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asanaLinkUpdate' is not null or undefined
            assertParamExists('updateChatUatAsanaScope', 'asanaLinkUpdate', asanaLinkUpdate)
            const localVarPath = `/chat-uat/validation/asana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asanaLinkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatUatApi - functional programming interface
 * @export
 */
export const ChatUatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatUatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Begin per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async beginChatUatAsanaAuthorization(asanaAuthorizationRequest: AsanaAuthorizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.beginChatUatAsanaAuthorization(asanaAuthorizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Complete per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaAuthorizationCompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove the linked Asana scope while retaining validation history
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatUatAsanaScope(version: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatUatAsanaScope(version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return bounded order content facts for ChatUAT validation
         * @param {string} orderId 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatContentFacts(orderId: string, stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatContentFacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatContentFacts(orderId, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a long-running ChatUAT turn
         * @param {string} conversationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatJob(conversationId: string, jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatJobStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatJob(conversationId, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Poll a deterministic Asana-scope validation job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatScopeValidationJob(jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatScopeValidationJob(jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one validation run and all bounded case results
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatScopeValidationRun(runId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationRun>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatScopeValidationRun(runId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the authenticated user\'s Asana validation state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatUatValidationState(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatUatValidationState(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolve a readable Asana project
         * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewChatUatAsanaScope(asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsanaProjectPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewChatUatAsanaScope(asanaLinkPreviewRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a long-running ChatUAT turn
         * @param {ChatUatJobRequest} chatUatJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatUatJob(chatUatJobRequest: ChatUatJobRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatJobStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatUatJob(chatUatJobRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start deterministic validation of the linked Asana test cases
         * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startChatUatScopeValidation(chatUatValidationStartRequest: ChatUatValidationStartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startChatUatScopeValidation(chatUatValidationStartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start or read automated ChatUAT analysis for a completed Raven result
         * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRavenChatUatAnalysis(ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RavenChatUatAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startRavenChatUatAnalysis(ravenChatUatAnalysisRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit feedback for a terminal ChatUAT response
         * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitChatUatFeedback(chatUatFeedbackRequest: ChatUatFeedbackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitChatUatFeedback(chatUatFeedbackRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save the Asana project used by ChatUAT
         * @param {AsanaLinkUpdate} asanaLinkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChatUatAsanaScope(asanaLinkUpdate: AsanaLinkUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUatValidationState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChatUatAsanaScope(asanaLinkUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatUatApi - factory interface
 * @export
 */
export const ChatUatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatUatApiFp(configuration)
    return {
        /**
         * 
         * @summary Begin per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beginChatUatAsanaAuthorization(asanaAuthorizationRequest: AsanaAuthorizationRequest, options?: any): AxiosPromise<AsanaAuthorizationResponse> {
            return localVarFp.beginChatUatAsanaAuthorization(asanaAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete per-user Asana authorization for ChatUAT
         * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options?: any): AxiosPromise<AsanaAuthorizationCompleteResponse> {
            return localVarFp.completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove the linked Asana scope while retaining validation history
         * @param {number} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatUatAsanaScope(version: number, options?: any): AxiosPromise<ChatUatValidationState> {
            return localVarFp.deleteChatUatAsanaScope(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return bounded order content facts for ChatUAT validation
         * @param {string} orderId 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatContentFacts(orderId: string, stage: Stage, options?: any): AxiosPromise<ChatUatContentFacts> {
            return localVarFp.getChatUatContentFacts(orderId, stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a long-running ChatUAT turn
         * @param {string} conversationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatJob(conversationId: string, jobId: string, options?: any): AxiosPromise<ChatUatJobStatusResponse> {
            return localVarFp.getChatUatJob(conversationId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll a deterministic Asana-scope validation job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationJob(jobId: string, options?: any): AxiosPromise<ChatUatValidationJobResponse> {
            return localVarFp.getChatUatScopeValidationJob(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one validation run and all bounded case results
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatScopeValidationRun(runId: string, options?: any): AxiosPromise<ChatUatValidationRun> {
            return localVarFp.getChatUatScopeValidationRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the authenticated user\'s Asana validation state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatUatValidationState(options?: any): AxiosPromise<ChatUatValidationState> {
            return localVarFp.getChatUatValidationState(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a readable Asana project
         * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewChatUatAsanaScope(asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options?: any): AxiosPromise<AsanaProjectPreview> {
            return localVarFp.previewChatUatAsanaScope(asanaLinkPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a long-running ChatUAT turn
         * @param {ChatUatJobRequest} chatUatJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatJob(chatUatJobRequest: ChatUatJobRequest, options?: any): AxiosPromise<ChatUatJobStartResponse> {
            return localVarFp.startChatUatJob(chatUatJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start deterministic validation of the linked Asana test cases
         * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startChatUatScopeValidation(chatUatValidationStartRequest: ChatUatValidationStartRequest, options?: any): AxiosPromise<ChatUatValidationJobResponse> {
            return localVarFp.startChatUatScopeValidation(chatUatValidationStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or read automated ChatUAT analysis for a completed Raven result
         * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRavenChatUatAnalysis(ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options?: any): AxiosPromise<RavenChatUatAnalysisResponse> {
            return localVarFp.startRavenChatUatAnalysis(ravenChatUatAnalysisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit feedback for a terminal ChatUAT response
         * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChatUatFeedback(chatUatFeedbackRequest: ChatUatFeedbackRequest, options?: any): AxiosPromise<ChatUatFeedbackResponse> {
            return localVarFp.submitChatUatFeedback(chatUatFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save the Asana project used by ChatUAT
         * @param {AsanaLinkUpdate} asanaLinkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChatUatAsanaScope(asanaLinkUpdate: AsanaLinkUpdate, options?: any): AxiosPromise<ChatUatValidationState> {
            return localVarFp.updateChatUatAsanaScope(asanaLinkUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatUatApi - object-oriented interface
 * @export
 * @class ChatUatApi
 * @extends {BaseAPI}
 */
export class ChatUatApi extends BaseAPI {
    /**
     * 
     * @summary Begin per-user Asana authorization for ChatUAT
     * @param {AsanaAuthorizationRequest} asanaAuthorizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public beginChatUatAsanaAuthorization(asanaAuthorizationRequest: AsanaAuthorizationRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).beginChatUatAsanaAuthorization(asanaAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete per-user Asana authorization for ChatUAT
     * @param {AsanaAuthorizationCompleteRequest} asanaAuthorizationCompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest: AsanaAuthorizationCompleteRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).completeChatUatAsanaAuthorization(asanaAuthorizationCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove the linked Asana scope while retaining validation history
     * @param {number} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public deleteChatUatAsanaScope(version: number, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).deleteChatUatAsanaScope(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return bounded order content facts for ChatUAT validation
     * @param {string} orderId 
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatContentFacts(orderId: string, stage: Stage, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatContentFacts(orderId, stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a long-running ChatUAT turn
     * @param {string} conversationId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatJob(conversationId: string, jobId: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatJob(conversationId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll a deterministic Asana-scope validation job
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatScopeValidationJob(jobId: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatScopeValidationJob(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one validation run and all bounded case results
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatScopeValidationRun(runId: string, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatScopeValidationRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the authenticated user\'s Asana validation state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public getChatUatValidationState(options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).getChatUatValidationState(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a readable Asana project
     * @param {AsanaLinkPreviewRequest} asanaLinkPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public previewChatUatAsanaScope(asanaLinkPreviewRequest: AsanaLinkPreviewRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).previewChatUatAsanaScope(asanaLinkPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a long-running ChatUAT turn
     * @param {ChatUatJobRequest} chatUatJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public startChatUatJob(chatUatJobRequest: ChatUatJobRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).startChatUatJob(chatUatJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start deterministic validation of the linked Asana test cases
     * @param {ChatUatValidationStartRequest} chatUatValidationStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public startChatUatScopeValidation(chatUatValidationStartRequest: ChatUatValidationStartRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).startChatUatScopeValidation(chatUatValidationStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or read automated ChatUAT analysis for a completed Raven result
     * @param {RavenChatUatAnalysisRequest} ravenChatUatAnalysisRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public startRavenChatUatAnalysis(ravenChatUatAnalysisRequest: RavenChatUatAnalysisRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).startRavenChatUatAnalysis(ravenChatUatAnalysisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit feedback for a terminal ChatUAT response
     * @param {ChatUatFeedbackRequest} chatUatFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public submitChatUatFeedback(chatUatFeedbackRequest: ChatUatFeedbackRequest, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).submitChatUatFeedback(chatUatFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save the Asana project used by ChatUAT
     * @param {AsanaLinkUpdate} asanaLinkUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatUatApi
     */
    public updateChatUatAsanaScope(asanaLinkUpdate: AsanaLinkUpdate, options?: AxiosRequestConfig) {
        return ChatUatApiFp(this.configuration).updateChatUatAsanaScope(asanaLinkUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get QuickSight dashboard embed URL
         * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardEmbedUrl: async (type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getDashboardEmbedUrl', 'type', type)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDashboardEmbedUrl', 'stage', stage)
            const localVarPath = `/dashboard/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get QuickSight dashboard embed URL
         * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardEmbedUrl(type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardEmbedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardEmbedUrl(type, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get QuickSight dashboard embed URL
         * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardEmbedUrl(type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options?: any): AxiosPromise<DashboardEmbedResponse> {
            return localVarFp.getDashboardEmbedUrl(type, stage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Get QuickSight dashboard embed URL
     * @param {'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels'} type 
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboardEmbedUrl(type: 'dlq' | 'testing' | 'pv_channels' | 'pv_addon' | 'pv_tvod' | 'royalty_recon_tvod' | 'royalty_recon_channels', stage: Stage, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboardEmbedUrl(type, stage, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DlqApi - axios parameter creator
 * @export
 */
export const DlqApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check DLQ status and get details for a transaction
         * @param {Stage} stage environment name
         * @param {string} [orderId] ID of the transaction to check
         * @param {string} [queryExecutionId] ID of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQInfo: async (stage: Stage, orderId?: string, queryExecutionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQInfo', 'stage', stage)
            const localVarPath = `/dlq-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (queryExecutionId !== undefined) {
                localVarQueryParameter['queryExecutionId'] = queryExecutionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DlqApi - functional programming interface
 * @export
 */
export const DlqApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DlqApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check DLQ status and get details for a transaction
         * @param {Stage} stage environment name
         * @param {string} [orderId] ID of the transaction to check
         * @param {string} [queryExecutionId] ID of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQInfo(stage: Stage, orderId?: string, queryExecutionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQInfo(stage, orderId, queryExecutionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DlqApi - factory interface
 * @export
 */
export const DlqApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DlqApiFp(configuration)
    return {
        /**
         * 
         * @summary Check DLQ status and get details for a transaction
         * @param {Stage} stage environment name
         * @param {string} [orderId] ID of the transaction to check
         * @param {string} [queryExecutionId] ID of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQInfo(stage: Stage, orderId?: string, queryExecutionId?: string, options?: any): AxiosPromise<DLQInfoResult> {
            return localVarFp.getDLQInfo(stage, orderId, queryExecutionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DlqApi - object-oriented interface
 * @export
 * @class DlqApi
 * @extends {BaseAPI}
 */
export class DlqApi extends BaseAPI {
    /**
     * 
     * @summary Check DLQ status and get details for a transaction
     * @param {Stage} stage environment name
     * @param {string} [orderId] ID of the transaction to check
     * @param {string} [queryExecutionId] ID of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqApi
     */
    public getDLQInfo(stage: Stage, orderId?: string, queryExecutionId?: string, options?: AxiosRequestConfig) {
        return DlqApiFp(this.configuration).getDLQInfo(stage, orderId, queryExecutionId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DlqRedriveApi - axios parameter creator
 * @export
 */
export const DlqRedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check DLQ redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveInfo: async (stage: Stage, executionArn: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQRedriveInfo', 'stage', stage)
            // verify required parameter 'executionArn' is not null or undefined
            assertParamExists('getDLQRedriveInfo', 'executionArn', executionArn)
            const localVarPath = `/dlq-redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (executionArn !== undefined) {
                localVarQueryParameter['executionArn'] = executionArn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get presigned URL for DLQ redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getDLQRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/dlq-redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all DLQ redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedrivesInfo: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDLQRedrivesInfo', 'stage', stage)
            const localVarPath = `/dlq-redrives-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start DLQ redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveInfo: async (stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postDLQRedriveInfo', 'stage', stage)
            // verify required parameter 'postDLQRedriveInfoRequest' is not null or undefined
            assertParamExists('postDLQRedriveInfo', 'postDLQRedriveInfoRequest', postDLQRedriveInfoRequest)
            const localVarPath = `/dlq-redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postDLQRedriveInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Draft MCM for deleting DLQ items without redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveMcm: async (stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postDLQRedriveMcm', 'stage', stage)
            // verify required parameter 'postDLQRedriveMcmRequest' is not null or undefined
            assertParamExists('postDLQRedriveMcm', 'postDLQRedriveMcmRequest', postDLQRedriveMcmRequest)
            const localVarPath = `/dlq-redrive-mcm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postDLQRedriveMcmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry a DLQ redrive by re-running a prior execution with the same input
         * @param {Stage} stage environment name
         * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryDLQRedrive: async (stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('retryDLQRedrive', 'stage', stage)
            // verify required parameter 'retryDLQRedriveRequest' is not null or undefined
            assertParamExists('retryDLQRedrive', 'retryDLQRedriveRequest', retryDLQRedriveRequest)
            const localVarPath = `/dlq-redrive-retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryDLQRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DlqRedriveApi - functional programming interface
 * @export
 */
export const DlqRedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DlqRedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check DLQ redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQRedriveInfo(stage: Stage, executionArn: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQRedriveInfo(stage, executionArn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get presigned URL for DLQ redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDLQRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all DLQ redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDLQRedrivesInfo(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDLQRedrivesInfo200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQRedrivesInfo(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start DLQ redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDLQRedriveInfo(stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDLQRedriveInfo(stage, postDLQRedriveInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a Draft MCM for deleting DLQ items without redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDLQRedriveMcm(stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostDLQRedriveMcm201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDLQRedriveMcm(stage, postDLQRedriveMcmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retry a DLQ redrive by re-running a prior execution with the same input
         * @param {Stage} stage environment name
         * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryDLQRedrive(stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQRedriveInfoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryDLQRedrive(stage, retryDLQRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DlqRedriveApi - factory interface
 * @export
 */
export const DlqRedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DlqRedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary Check DLQ redrive status
         * @param {Stage} stage environment name
         * @param {string} executionArn Arn of the query execution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveInfo(stage: Stage, executionArn: string, options?: any): AxiosPromise<DLQRedriveInfoResult> {
            return localVarFp.getDLQRedriveInfo(stage, executionArn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get presigned URL for DLQ redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName name of the file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetDLQRedriveUploadUrl200Response> {
            return localVarFp.getDLQRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all DLQ redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDLQRedrivesInfo(stage: Stage, options?: any): AxiosPromise<Array<GetDLQRedrivesInfo200ResponseInner>> {
            return localVarFp.getDLQRedrivesInfo(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start DLQ redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveInfo(stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options?: any): AxiosPromise<DLQRedriveInfoResult> {
            return localVarFp.postDLQRedriveInfo(stage, postDLQRedriveInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Draft MCM for deleting DLQ items without redrive
         * @param {Stage} stage environment name
         * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDLQRedriveMcm(stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options?: any): AxiosPromise<PostDLQRedriveMcm201Response> {
            return localVarFp.postDLQRedriveMcm(stage, postDLQRedriveMcmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry a DLQ redrive by re-running a prior execution with the same input
         * @param {Stage} stage environment name
         * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryDLQRedrive(stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options?: any): AxiosPromise<DLQRedriveInfoResult> {
            return localVarFp.retryDLQRedrive(stage, retryDLQRedriveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DlqRedriveApi - object-oriented interface
 * @export
 * @class DlqRedriveApi
 * @extends {BaseAPI}
 */
export class DlqRedriveApi extends BaseAPI {
    /**
     * 
     * @summary Check DLQ redrive status
     * @param {Stage} stage environment name
     * @param {string} executionArn Arn of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public getDLQRedriveInfo(stage: Stage, executionArn: string, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).getDLQRedriveInfo(stage, executionArn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get presigned URL for DLQ redrive file upload
     * @param {Stage} stage environment name
     * @param {string} fileName name of the file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public getDLQRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).getDLQRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all DLQ redrive executions
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public getDLQRedrivesInfo(stage: Stage, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).getDLQRedrivesInfo(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start DLQ redrive
     * @param {Stage} stage environment name
     * @param {PostDLQRedriveInfoRequest} postDLQRedriveInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public postDLQRedriveInfo(stage: Stage, postDLQRedriveInfoRequest: PostDLQRedriveInfoRequest, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).postDLQRedriveInfo(stage, postDLQRedriveInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Draft MCM for deleting DLQ items without redrive
     * @param {Stage} stage environment name
     * @param {PostDLQRedriveMcmRequest} postDLQRedriveMcmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public postDLQRedriveMcm(stage: Stage, postDLQRedriveMcmRequest: PostDLQRedriveMcmRequest, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).postDLQRedriveMcm(stage, postDLQRedriveMcmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry a DLQ redrive by re-running a prior execution with the same input
     * @param {Stage} stage environment name
     * @param {RetryDLQRedriveRequest} retryDLQRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DlqRedriveApi
     */
    public retryDLQRedrive(stage: Stage, retryDLQRedriveRequest: RetryDLQRedriveRequest, options?: AxiosRequestConfig) {
        return DlqRedriveApiFp(this.configuration).retryDLQRedrive(stage, retryDLQRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * DownloadS3FileApi - axios parameter creator
 * @export
 */
export const DownloadS3FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download S3 File
         * @param {string} key file name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('download', 'key', key)
            const localVarPath = `/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadS3FileApi - functional programming interface
 * @export
 */
export const DownloadS3FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadS3FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download S3 File
         * @param {string} key file name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadS3FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DownloadS3FileApi - factory interface
 * @export
 */
export const DownloadS3FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadS3FileApiFp(configuration)
    return {
        /**
         * 
         * @summary Download S3 File
         * @param {string} key file name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(key: string, options?: any): AxiosPromise<DownloadS3FileResponse> {
            return localVarFp.download(key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadS3FileApi - object-oriented interface
 * @export
 * @class DownloadS3FileApi
 * @extends {BaseAPI}
 */
export class DownloadS3FileApi extends BaseAPI {
    /**
     * 
     * @summary Download S3 File
     * @param {string} key file name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadS3FileApi
     */
    public download(key: string, options?: AxiosRequestConfig) {
        return DownloadS3FileApiFp(this.configuration).download(key, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getDetails', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getDetails', 'orderId', orderId)
            const localVarPath = `/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of events with different versions
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getEvents', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getEvents', 'orderId', orderId)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Product/episode summary from the decompressed event body
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderContents: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getOrderContents', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderContents', 'orderId', orderId)
            const localVarPath = `/order-contents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of events with different versions
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Product/episode summary from the decompressed event body
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderContents(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderContentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderContents(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary List of CBEs and events
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(stage: Stage, orderId: string, options?: any): AxiosPromise<DetailsResponse> {
            return localVarFp.getDetails(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of events with different versions
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(stage: Stage, orderId: string, options?: any): AxiosPromise<Array<Event>> {
            return localVarFp.getEvents(stage, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Product/episode summary from the decompressed event body
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderContents(stage: Stage, orderId: string, options?: any): AxiosPromise<OrderContentsResponse> {
            return localVarFp.getOrderContents(stage, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @summary List of CBEs and events
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getDetails(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getDetails(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of events with different versions
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEvents(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEvents(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Product/episode summary from the decompressed event body
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getOrderContents(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getOrderContents(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * MatchSetsApi - axios parameter creator
 * @export
 */
export const MatchSetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get match set statuses for an order
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchSets: async (stage: Stage, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getMatchSets', 'stage', stage)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getMatchSets', 'orderId', orderId)
            const localVarPath = `/match-sets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchSetsApi - functional programming interface
 * @export
 */
export const MatchSetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchSetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get match set statuses for an order
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchSets(stage: Stage, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchSetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchSets(stage, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatchSetsApi - factory interface
 * @export
 */
export const MatchSetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchSetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get match set statuses for an order
         * @param {Stage} stage environment name
         * @param {string} orderId ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchSets(stage: Stage, orderId: string, options?: any): AxiosPromise<MatchSetResponse> {
            return localVarFp.getMatchSets(stage, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatchSetsApi - object-oriented interface
 * @export
 * @class MatchSetsApi
 * @extends {BaseAPI}
 */
export class MatchSetsApi extends BaseAPI {
    /**
     * 
     * @summary Get match set statuses for an order
     * @param {Stage} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchSetsApi
     */
    public getMatchSets(stage: Stage, orderId: string, options?: AxiosRequestConfig) {
        return MatchSetsApiFp(this.configuration).getMatchSets(stage, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PaymentRedriveApi - axios parameter creator
 * @export
 */
export const PaymentRedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get presigned URL for payment redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getPaymentRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getPaymentRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/payment-redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redrive a ManualRoyaltyAdjustment cost document
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedrive: async (stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postPaymentRedrive', 'stage', stage)
            // verify required parameter 'postPaymentRedriveRequest' is not null or undefined
            assertParamExists('postPaymentRedrive', 'postPaymentRedriveRequest', postPaymentRedriveRequest)
            const localVarPath = `/payment-redrive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRedriveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a bulk payment redrive from a CSV file in S3
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedriveBulk: async (stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postPaymentRedriveBulk', 'stage', stage)
            // verify required parameter 'postPaymentRedriveBulkRequest' is not null or undefined
            assertParamExists('postPaymentRedriveBulk', 'postPaymentRedriveBulkRequest', postPaymentRedriveBulkRequest)
            const localVarPath = `/payment-redrive-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRedriveBulkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentRedriveApi - functional programming interface
 * @export
 */
export const PaymentRedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentRedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get presigned URL for payment redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDLQRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Redrive a ManualRoyaltyAdjustment cost document
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentRedrive(stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishMockAcadiaInvoice202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentRedrive(stage, postPaymentRedriveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a bulk payment redrive from a CSV file in S3
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentRedriveBulk(stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedriveOrder202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentRedriveBulk(stage, postPaymentRedriveBulkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentRedriveApi - factory interface
 * @export
 */
export const PaymentRedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentRedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary Get presigned URL for payment redrive file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetDLQRedriveUploadUrl200Response> {
            return localVarFp.getPaymentRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redrive a ManualRoyaltyAdjustment cost document
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedrive(stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options?: any): AxiosPromise<PublishMockAcadiaInvoice202Response> {
            return localVarFp.postPaymentRedrive(stage, postPaymentRedriveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a bulk payment redrive from a CSV file in S3
         * @param {Stage} stage environment name
         * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRedriveBulk(stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options?: any): AxiosPromise<PostRedriveOrder202Response> {
            return localVarFp.postPaymentRedriveBulk(stage, postPaymentRedriveBulkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentRedriveApi - object-oriented interface
 * @export
 * @class PaymentRedriveApi
 * @extends {BaseAPI}
 */
export class PaymentRedriveApi extends BaseAPI {
    /**
     * 
     * @summary Get presigned URL for payment redrive file upload
     * @param {Stage} stage environment name
     * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRedriveApi
     */
    public getPaymentRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return PaymentRedriveApiFp(this.configuration).getPaymentRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redrive a ManualRoyaltyAdjustment cost document
     * @param {Stage} stage environment name
     * @param {PostPaymentRedriveRequest} postPaymentRedriveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRedriveApi
     */
    public postPaymentRedrive(stage: Stage, postPaymentRedriveRequest: PostPaymentRedriveRequest, options?: AxiosRequestConfig) {
        return PaymentRedriveApiFp(this.configuration).postPaymentRedrive(stage, postPaymentRedriveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a bulk payment redrive from a CSV file in S3
     * @param {Stage} stage environment name
     * @param {PostPaymentRedriveBulkRequest} postPaymentRedriveBulkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentRedriveApi
     */
    public postPaymentRedriveBulk(stage: Stage, postPaymentRedriveBulkRequest: PostPaymentRedriveBulkRequest, options?: AxiosRequestConfig) {
        return PaymentRedriveApiFp(this.configuration).postPaymentRedriveBulk(stage, postPaymentRedriveBulkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction: async (projectId: string, transactionCreate: TransactionCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addTransaction', 'projectId', projectId)
            // verify required parameter 'transactionCreate' is not null or undefined
            assertParamExists('addTransaction', 'transactionCreate', transactionCreate)
            const localVarPath = `/projects/{projectId}/transactions`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new UAT project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (projectCreate: ProjectCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCreate' is not null or undefined
            assertParamExists('createProject', 'projectCreate', projectCreate)
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProject', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all UAT projects
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects: async (includeArchived?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (projectId: string, projectUpdate: ProjectUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProject', 'projectId', projectId)
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('updateProject', 'projectUpdate', projectUpdate)
            const localVarPath = `/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction: async (projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateTransaction', 'projectId', projectId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('updateTransaction', 'transactionId', transactionId)
            // verify required parameter 'transactionUpdate' is not null or undefined
            assertParamExists('updateTransaction', 'transactionUpdate', transactionUpdate)
            const localVarPath = `/projects/{projectId}/transactions/{transactionId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTransaction(projectId, transactionCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new UAT project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(projectCreate: ProjectCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(projectCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a specific project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProject(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all UAT projects
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProjects(includeArchived?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProjects200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProjects(includeArchived, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(projectId, projectUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransaction(projectId, transactionId, transactionUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: any): AxiosPromise<Project> {
            return localVarFp.addTransaction(projectId, transactionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new UAT project
         * @param {ProjectCreate} projectCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(projectCreate: ProjectCreate, options?: any): AxiosPromise<Project> {
            return localVarFp.createProject(projectCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(projectId: string, options?: any): AxiosPromise<Project> {
            return localVarFp.getProject(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all UAT projects
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(includeArchived?: boolean, options?: any): AxiosPromise<ListProjects200Response> {
            return localVarFp.listProjects(includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a project
         * @param {string} projectId 
         * @param {ProjectUpdate} projectUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: any): AxiosPromise<Project> {
            return localVarFp.updateProject(projectId, projectUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: any): AxiosPromise<Project> {
            return localVarFp.updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @summary Add a transaction to a project
     * @param {string} projectId 
     * @param {TransactionCreate} transactionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).addTransaction(projectId, transactionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new UAT project
     * @param {ProjectCreate} projectCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public createProject(projectCreate: ProjectCreate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProject(projectCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific project
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProject(projectId: string, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProject(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all UAT projects
     * @param {boolean} [includeArchived] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public listProjects(includeArchived?: boolean, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).listProjects(includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a project
     * @param {string} projectId 
     * @param {ProjectUpdate} projectUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public updateProject(projectId: string, projectUpdate: ProjectUpdate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateProject(projectId, projectUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a transaction in a project
     * @param {string} projectId 
     * @param {string} transactionId 
     * @param {TransactionUpdate} transactionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * PublishMockAcadiaInvoiceApi - axios parameter creator
 * @export
 */
export const PublishMockAcadiaInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Publish mock Acadia invoice
         * @param {Stage} stage environment name
         * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMockAcadiaInvoice: async (stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('publishMockAcadiaInvoice', 'stage', stage)
            // verify required parameter 'publishMockAcadiaInvoiceRequest' is not null or undefined
            assertParamExists('publishMockAcadiaInvoice', 'publishMockAcadiaInvoiceRequest', publishMockAcadiaInvoiceRequest)
            const localVarPath = `/publish-mock-acadia-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishMockAcadiaInvoiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublishMockAcadiaInvoiceApi - functional programming interface
 * @export
 */
export const PublishMockAcadiaInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublishMockAcadiaInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Publish mock Acadia invoice
         * @param {Stage} stage environment name
         * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishMockAcadiaInvoice(stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishMockAcadiaInvoice202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishMockAcadiaInvoice(stage, publishMockAcadiaInvoiceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublishMockAcadiaInvoiceApi - factory interface
 * @export
 */
export const PublishMockAcadiaInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublishMockAcadiaInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Publish mock Acadia invoice
         * @param {Stage} stage environment name
         * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMockAcadiaInvoice(stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options?: any): AxiosPromise<PublishMockAcadiaInvoice202Response> {
            return localVarFp.publishMockAcadiaInvoice(stage, publishMockAcadiaInvoiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublishMockAcadiaInvoiceApi - object-oriented interface
 * @export
 * @class PublishMockAcadiaInvoiceApi
 * @extends {BaseAPI}
 */
export class PublishMockAcadiaInvoiceApi extends BaseAPI {
    /**
     * 
     * @summary Publish mock Acadia invoice
     * @param {Stage} stage environment name
     * @param {PublishMockAcadiaInvoiceRequest} publishMockAcadiaInvoiceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublishMockAcadiaInvoiceApi
     */
    public publishMockAcadiaInvoice(stage: Stage, publishMockAcadiaInvoiceRequest: PublishMockAcadiaInvoiceRequest, options?: AxiosRequestConfig) {
        return PublishMockAcadiaInvoiceApiFp(this.configuration).publishMockAcadiaInvoice(stage, publishMockAcadiaInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * RedriveApi - axios parameter creator
 * @export
 */
export const RedriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveInfo: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRedriveInfo', 'stage', stage)
            const localVarPath = `/redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get orders processed in a specific redrive execution
         * @param {string} executionId ID of the redrive execution
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveOrders: async (executionId: string, stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executionId' is not null or undefined
            assertParamExists('getRedriveOrders', 'executionId', executionId)
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRedriveOrders', 'stage', stage)
            const localVarPath = `/redrive-info/{executionId}/orders`
                .replace(`{${"executionId"}}`, encodeURIComponent(String(executionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get presigned URL for file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveUploadUrl: async (stage: Stage, fileName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRedriveUploadUrl', 'stage', stage)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getRedriveUploadUrl', 'fileName', fileName)
            const localVarPath = `/redrive-upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new redrive request
         * @param {Stage} stage environment name
         * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveInfo: async (stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postRedriveInfo', 'stage', stage)
            // verify required parameter 'postRedriveInfoRequest' is not null or undefined
            assertParamExists('postRedriveInfo', 'postRedriveInfoRequest', postRedriveInfoRequest)
            const localVarPath = `/redrive-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRedriveInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
         * @summary Redrive a single order
         * @param {Stage} stage environment name
         * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveOrder: async (stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('postRedriveOrder', 'stage', stage)
            // verify required parameter 'postRedriveOrderRequest' is not null or undefined
            assertParamExists('postRedriveOrder', 'postRedriveOrderRequest', postRedriveOrderRequest)
            const localVarPath = `/redrive-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRedriveOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedriveApi - functional programming interface
 * @export
 */
export const RedriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedriveInfo(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRedriveInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedriveInfo(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get orders processed in a specific redrive execution
         * @param {string} executionId ID of the redrive execution
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedriveOrders(executionId: string, stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRedriveOrders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedriveOrders(executionId, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get presigned URL for file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDLQRedriveUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedriveUploadUrl(stage, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start a new redrive request
         * @param {Stage} stage environment name
         * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRedriveInfo(stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedriveInfo202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRedriveInfo(stage, postRedriveInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
         * @summary Redrive a single order
         * @param {Stage} stage environment name
         * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRedriveOrder(stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRedriveOrder202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRedriveOrder(stage, postRedriveOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RedriveApi - factory interface
 * @export
 */
export const RedriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedriveApiFp(configuration)
    return {
        /**
         * 
         * @summary List all redrive executions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveInfo(stage: Stage, options?: any): AxiosPromise<GetRedriveInfo200Response> {
            return localVarFp.getRedriveInfo(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get orders processed in a specific redrive execution
         * @param {string} executionId ID of the redrive execution
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveOrders(executionId: string, stage: Stage, options?: any): AxiosPromise<GetRedriveOrders200Response> {
            return localVarFp.getRedriveOrders(executionId, stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get presigned URL for file upload
         * @param {Stage} stage environment name
         * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedriveUploadUrl(stage: Stage, fileName: string, options?: any): AxiosPromise<GetDLQRedriveUploadUrl200Response> {
            return localVarFp.getRedriveUploadUrl(stage, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new redrive request
         * @param {Stage} stage environment name
         * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveInfo(stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options?: any): AxiosPromise<PostRedriveInfo202Response> {
            return localVarFp.postRedriveInfo(stage, postRedriveInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
         * @summary Redrive a single order
         * @param {Stage} stage environment name
         * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRedriveOrder(stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options?: any): AxiosPromise<PostRedriveOrder202Response> {
            return localVarFp.postRedriveOrder(stage, postRedriveOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedriveApi - object-oriented interface
 * @export
 * @class RedriveApi
 * @extends {BaseAPI}
 */
export class RedriveApi extends BaseAPI {
    /**
     * 
     * @summary List all redrive executions
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public getRedriveInfo(stage: Stage, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).getRedriveInfo(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get orders processed in a specific redrive execution
     * @param {string} executionId ID of the redrive execution
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public getRedriveOrders(executionId: string, stage: Stage, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).getRedriveOrders(executionId, stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get presigned URL for file upload
     * @param {Stage} stage environment name
     * @param {string} fileName Bare filename only (e.g. \&quot;my_redrive.csv\&quot;), without any path prefix. The server generates the full S3 key automatically. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public getRedriveUploadUrl(stage: Stage, fileName: string, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).getRedriveUploadUrl(stage, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new redrive request
     * @param {Stage} stage environment name
     * @param {PostRedriveInfoRequest} postRedriveInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public postRedriveInfo(stage: Stage, postRedriveInfoRequest: PostRedriveInfoRequest, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).postRedriveInfo(stage, postRedriveInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a one-order CSV server-side and starts the existing order redrive workflow. The caller does not need to provide an S3 URI. 
     * @summary Redrive a single order
     * @param {Stage} stage environment name
     * @param {PostRedriveOrderRequest} postRedriveOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedriveApi
     */
    public postRedriveOrder(stage: Stage, postRedriveOrderRequest: PostRedriveOrderRequest, options?: AxiosRequestConfig) {
        return RedriveApiFp(this.configuration).postRedriveOrder(stage, postRedriveOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * ShadowTestApi - axios parameter creator
 * @export
 */
export const ShadowTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Trigger a shadow test for a list of transactions
         * @param {Stage} stage environment name (prod, beta, etc)
         * @param {CreateShadowTestRequest} createShadowTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShadowTest: async (stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('createShadowTest', 'stage', stage)
            // verify required parameter 'createShadowTestRequest' is not null or undefined
            assertParamExists('createShadowTest', 'createShadowTestRequest', createShadowTestRequest)
            const localVarPath = `/shadow-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShadowTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get shadow test classification descriptions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestClassifications: async (stage: Stage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getShadowTestClassifications', 'stage', stage)
            const localVarPath = `/shadow-test-classifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get shadow test result for a transaction
         * @param {Stage} stage environment name
         * @param {string} transactionId Transaction ID to fetch results for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestResult: async (stage: Stage, transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getShadowTestResult', 'stage', stage)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getShadowTestResult', 'transactionId', transactionId)
            const localVarPath = `/shadow-test-result/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShadowTestApi - functional programming interface
 * @export
 */
export const ShadowTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShadowTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Trigger a shadow test for a list of transactions
         * @param {Stage} stage environment name (prod, beta, etc)
         * @param {CreateShadowTestRequest} createShadowTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShadowTest(stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShadowTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShadowTest(stage, createShadowTestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get shadow test classification descriptions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShadowTestClassifications(stage: Stage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShadowTestClassificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShadowTestClassifications(stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get shadow test result for a transaction
         * @param {Stage} stage environment name
         * @param {string} transactionId Transaction ID to fetch results for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShadowTestResult(stage: Stage, transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShadowTestResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShadowTestResult(stage, transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShadowTestApi - factory interface
 * @export
 */
export const ShadowTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShadowTestApiFp(configuration)
    return {
        /**
         * 
         * @summary Trigger a shadow test for a list of transactions
         * @param {Stage} stage environment name (prod, beta, etc)
         * @param {CreateShadowTestRequest} createShadowTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShadowTest(stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options?: any): AxiosPromise<ShadowTestResponse> {
            return localVarFp.createShadowTest(stage, createShadowTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get shadow test classification descriptions
         * @param {Stage} stage environment name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestClassifications(stage: Stage, options?: any): AxiosPromise<ShadowTestClassificationsResponse> {
            return localVarFp.getShadowTestClassifications(stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get shadow test result for a transaction
         * @param {Stage} stage environment name
         * @param {string} transactionId Transaction ID to fetch results for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShadowTestResult(stage: Stage, transactionId: string, options?: any): AxiosPromise<ShadowTestResultResponse> {
            return localVarFp.getShadowTestResult(stage, transactionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShadowTestApi - object-oriented interface
 * @export
 * @class ShadowTestApi
 * @extends {BaseAPI}
 */
export class ShadowTestApi extends BaseAPI {
    /**
     * 
     * @summary Trigger a shadow test for a list of transactions
     * @param {Stage} stage environment name (prod, beta, etc)
     * @param {CreateShadowTestRequest} createShadowTestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowTestApi
     */
    public createShadowTest(stage: Stage, createShadowTestRequest: CreateShadowTestRequest, options?: AxiosRequestConfig) {
        return ShadowTestApiFp(this.configuration).createShadowTest(stage, createShadowTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get shadow test classification descriptions
     * @param {Stage} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowTestApi
     */
    public getShadowTestClassifications(stage: Stage, options?: AxiosRequestConfig) {
        return ShadowTestApiFp(this.configuration).getShadowTestClassifications(stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get shadow test result for a transaction
     * @param {Stage} stage environment name
     * @param {string} transactionId Transaction ID to fetch results for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShadowTestApi
     */
    public getShadowTestResult(stage: Stage, transactionId: string, options?: AxiosRequestConfig) {
        return ShadowTestApiFp(this.configuration).getShadowTestResult(stage, transactionId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction: async (projectId: string, transactionCreate: TransactionCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addTransaction', 'projectId', projectId)
            // verify required parameter 'transactionCreate' is not null or undefined
            assertParamExists('addTransaction', 'transactionCreate', transactionCreate)
            const localVarPath = `/projects/{projectId}/transactions`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recent transactions across regions
         * @param {Stage} stage environment name
         * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
         * @param {string} [gl] GL code to filter by (e.g., 318, 613)
         * @param {Array<string>} [usecases] usecase types to filter by
         * @param {string} [paymentMethod] filter for payment methods
         * @param {string} [paymentMethodClass] filter for payment method class
         * @param {number} [endTime] timestamp for pagination
         * @param {boolean} [deep] whether to perform a deep searrch
         * @param {Array<string>} [features] additional features to apply to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentTransactions: async (stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentMethodClass?: string, endTime?: number, deep?: boolean, features?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stage' is not null or undefined
            assertParamExists('getRecentTransactions', 'stage', stage)
            const localVarPath = `/recent-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (gl !== undefined) {
                localVarQueryParameter['gl'] = gl;
            }

            if (usecases) {
                localVarQueryParameter['usecases'] = usecases;
            }

            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }

            if (paymentMethodClass !== undefined) {
                localVarQueryParameter['paymentMethodClass'] = paymentMethodClass;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (deep !== undefined) {
                localVarQueryParameter['deep'] = deep;
            }

            if (features) {
                localVarQueryParameter['features'] = features;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction: async (projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateTransaction', 'projectId', projectId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('updateTransaction', 'transactionId', transactionId)
            // verify required parameter 'transactionUpdate' is not null or undefined
            assertParamExists('updateTransaction', 'transactionUpdate', transactionUpdate)
            const localVarPath = `/projects/{projectId}/transactions/{transactionId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTransaction(projectId, transactionCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get recent transactions across regions
         * @param {Stage} stage environment name
         * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
         * @param {string} [gl] GL code to filter by (e.g., 318, 613)
         * @param {Array<string>} [usecases] usecase types to filter by
         * @param {string} [paymentMethod] filter for payment methods
         * @param {string} [paymentMethodClass] filter for payment method class
         * @param {number} [endTime] timestamp for pagination
         * @param {boolean} [deep] whether to perform a deep searrch
         * @param {Array<string>} [features] additional features to apply to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentTransactions(stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentMethodClass?: string, endTime?: number, deep?: boolean, features?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecentTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentTransactions(stage, countries, gl, usecases, paymentMethod, paymentMethodClass, endTime, deep, features, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransaction(projectId, transactionId, transactionUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a transaction to a project
         * @param {string} projectId 
         * @param {TransactionCreate} transactionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: any): AxiosPromise<Project> {
            return localVarFp.addTransaction(projectId, transactionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recent transactions across regions
         * @param {Stage} stage environment name
         * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
         * @param {string} [gl] GL code to filter by (e.g., 318, 613)
         * @param {Array<string>} [usecases] usecase types to filter by
         * @param {string} [paymentMethod] filter for payment methods
         * @param {string} [paymentMethodClass] filter for payment method class
         * @param {number} [endTime] timestamp for pagination
         * @param {boolean} [deep] whether to perform a deep searrch
         * @param {Array<string>} [features] additional features to apply to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentTransactions(stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentMethodClass?: string, endTime?: number, deep?: boolean, features?: Array<string>, options?: any): AxiosPromise<RecentTransactionsResponse> {
            return localVarFp.getRecentTransactions(stage, countries, gl, usecases, paymentMethod, paymentMethodClass, endTime, deep, features, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a transaction in a project
         * @param {string} projectId 
         * @param {string} transactionId 
         * @param {TransactionUpdate} transactionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: any): AxiosPromise<Project> {
            return localVarFp.updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     * 
     * @summary Add a transaction to a project
     * @param {string} projectId 
     * @param {TransactionCreate} transactionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public addTransaction(projectId: string, transactionCreate: TransactionCreate, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).addTransaction(projectId, transactionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recent transactions across regions
     * @param {Stage} stage environment name
     * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
     * @param {string} [gl] GL code to filter by (e.g., 318, 613)
     * @param {Array<string>} [usecases] usecase types to filter by
     * @param {string} [paymentMethod] filter for payment methods
     * @param {string} [paymentMethodClass] filter for payment method class
     * @param {number} [endTime] timestamp for pagination
     * @param {boolean} [deep] whether to perform a deep searrch
     * @param {Array<string>} [features] additional features to apply to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public getRecentTransactions(stage: Stage, countries?: Array<string>, gl?: string, usecases?: Array<string>, paymentMethod?: string, paymentMethodClass?: string, endTime?: number, deep?: boolean, features?: Array<string>, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).getRecentTransactions(stage, countries, gl, usecases, paymentMethod, paymentMethodClass, endTime, deep, features, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a transaction in a project
     * @param {string} projectId 
     * @param {string} transactionId 
     * @param {TransactionUpdate} transactionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    public updateTransaction(projectId: string, transactionId: string, transactionUpdate: TransactionUpdate, options?: AxiosRequestConfig) {
        return TransactionsApiFp(this.configuration).updateTransaction(projectId, transactionId, transactionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

